import * as React from 'react';
import { ApplicationState, AppState, CaseSettingsState, VehicleState } from '../../store';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { IReferentialService } from '../../services/Interfaces/IReferentialService';
import { IAppUserService } from '../../services/Interfaces/IAppUserService';
import { withSnackbar, ProviderContext } from 'notistack';
import { IOrderService } from '../../services/Interfaces/IOrderService';
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  TextField,
  Tooltip
} from '@material-ui/core';
import HistoryIcon from '@material-ui/icons/History';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { ScaleLoader } from 'react-spinners';
import MUIDataTable, {
  MUIDataTableColumnOptions,
  MUIDataTableMeta,
  SelectableRows,
  MUIDataTableColumnDef
} from 'mui-datatables';
import { MUITranslations } from '../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import EditIcon from '@material-ui/icons/Edit';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  CaseAttachment,
  CaseCalculationAlternativePart,
  CaseCalculationPart,
  CaseCalculationSupplierAlternativePart,
  GetSuppliersAlternativePartsRequestDto,
  Model,
  NonStockPart,
  QuantityWarningInfo,
  TariffPercentResponse,
  UpdateOrderInfoRequest
} from '../../interfaces/Case';
import {
  Order,
  OrderPart,
  OrderPartDTO,
  OrderStatusChangeRequestDto,
  OrderStatusHistory,
  PartToBeOrdered,
  UpdateOrderAmountsRequestDto,
  ExtendDeliveryRequestDto,
  ExtendDeliveryResponseDto,
  OrderPartDeliveryDateHistory
} from '../../interfaces/Order';
import { isNull, isNullOrUndefined } from 'util';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/ro';
import Referentials from '../../helpers/Referentials.json';
import {
  ReferentialCode,
  ParametreCode,
  OrganizationTypeCode,
  OrderStatusTypesCode,
  AttachmentTypeCode,
  OrderStatusCode,
  OrderPartStatus,
  SupplierCode,
  OwnStockCodeEnum,
  AdditionalInfoCode,
  AlternativeCode,
  RoleClaimsEnum,
  CarPartQualityTypeCode,
  OrderNotificationTemplateEnum,
  CountryCodeEnum
} from '../../helpers/Constants';
import { IReferential } from '../../interfaces/IReferential';
import FileSaver from 'file-saver';
import { ICaseService } from '../../services/Interfaces/ICaseService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormHelpers } from '../../helpers/forms/FormHelpers';
import {
  GetSuppliersByStatusRequestDto,
  Workflow,
  WorkflowSectionStepForm
} from '../../interfaces/Workflow';
import * as R from 'ramda';
import { map } from 'ramda';
import { isUndefined, rest } from 'lodash';
import { red } from '@material-ui/core/colors';
import { pretUnitarFormat } from '../../utils/orderUtils';
import { mapAlternativePartToCalculationPart } from '../../utils/calculationPartUtils';
import { OrganizationService } from '../../services/OrganizationService';
import { IOrganizationService } from '../../services/Interfaces/IOrganizationService';
import { Organization } from '../../interfaces/Organization';
import { AlignRight } from 'react-feather';
import _ from 'lodash';
import { VehicleHelper } from '../../helpers/VehicleHelper';
import { Utils } from '../../helpers/Utils';
import { IWorkflowService } from '../../services/Interfaces/IWorkflowService';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import MuiTheme from '../../theme';
import { v4 as uuid } from 'uuid';
import { OrderParts } from '../../interfaces/OrderParts';
import { EditComponentProps } from 'material-table';
import { IRefreshService } from '../../services/Interfaces/IRefreshService';
import { Subject, takeUntil } from 'rxjs';
import RequeryDialog from './RequeryDialog';
import QuantityWarningDialog from '../_shared/QuantityWarningDialog';
import ConfirmDialog from '../_shared/ConfirmDialog';

export interface ExternalOrderDetailsProps {
  orderDetails: Order;
  onOrderChange: (order: Order) => void;
  hasRights: boolean;
  additionTariff: TariffPercentResponse;
  discountTariff: TariffPercentResponse;
  automatePlaceOrder: boolean;
  workflowAutomatePlaceOrder: boolean;
  automatePlaceOrderChange: () => Promise<void>;
  onOrderPlacedSuccessfully: () => void;
}

type OrderDetailsProps = ExternalOrderDetailsProps & {
  caseSettingsState: CaseSettingsState;
  appState: AppState;
  vehicleState: VehicleState;
} & ProviderContext &
  RouteComponentProps;

interface IOrderDetailsState {
  userStartCode: string;
  isLoadingOrderDetails: boolean;
  orderpartsList: OrderPartDTO[];
  isChangeOrderStatusDialogOpen: boolean;
  changeOrderStatusComment: string;
  statuses: IReferential[];
  selectedStatus: IReferential;
  orderPartStatus: IReferential[];
  orderStatuses: IReferential[];
  selectedDisplayedStatus: string;
  attachments: CaseAttachment[];
  orderStatusHistory: OrderStatusHistory[];
  TVA: string;
  attachType: IReferential | null;
  partsLocationOrganization: Organization | null;
  caseCalculationPartsThatChangedDuringPlacingOrder: CaseCalculationSupplierAlternativePart[];
  organizationId: number | null;
  organizations: Organization[];
  showOrderPrice: boolean;
  costCenter: IReferential | null;
  executing: boolean;
  quality: IReferential | null;
  rowsExpanded: number[];
  firstCasePartToBeOrdered: PartToBeOrdered | null;
  hasSupplierRole: boolean;
  model: Model | null;
  interventionType: IReferential | null;
  workflow: Workflow | null;
  isRequeryDialogOpen: boolean;
  pendingDeletePartId: number | null;
  pendingUpdateStatusPartId: number | null;
  isCancelPartRequeryDialogOpen: boolean;
  isDialogOpenQuantityWarning: boolean;
  quantityWarningInfo: QuantityWarningInfo | null;
  quantityWarningPendingAction: (() => void) | null;
  isStockExceededConfirmOpen: boolean;
  stockExceededPendingAction: (() => void) | null;
  extensionDays: number | null;
  isExtendDialogOpen: boolean;
  selectedOrderPart: OrderPartDTO | null;
  isHistoryDialogOpen: boolean;
  historyDialogData: OrderPartDeliveryDateHistory[];
}

const MAX_EXTENSION_DAYS = 30;

class OrderDetails extends React.PureComponent<OrderDetailsProps, IOrderDetailsState> {
  private translatorService!: ITranslatorService;
  private orderService!: IOrderService;
  private appReferentialService!: IReferentialService;
  private appUserService!: IAppUserService;
  private caseService!: ICaseService;
  private organizationService!: IOrganizationService;
  private workflowService!: IWorkflowService;
  static contextType = ApplicationContext;
  private refreshService!: IRefreshService;
  private destroy: Subject<void> = new Subject<void>();

  state = {
    userStartCode: '',
    isLoadingOrderDetails: true,
    orderpartsList: [],
    isChangeOrderStatusDialogOpen: false,
    changeOrderStatusComment: '',
    statuses: [] as IReferential[],
    selectedStatus: this.props.orderDetails.orderStatus,
    orderPartStatus: [],
    orderStatuses: [],
    selectedDisplayedStatus: '',
    attachments: [],
    orderStatusHistory: [],
    TVA: '0',
    attachType: null,
    partsLocationOrganization: null,
    caseCalculationPartsThatChangedDuringPlacingOrder: [],
    organizationId: this.props.appState.appUser!.organizationId,
    organizations: [],
    showOrderPrice: false,
    costCenter: null,
    executing: false,
    quality: null,
    rowsExpanded: [],
    firstCasePartToBeOrdered: null,
    hasSupplierRole: false,
    model: null,
    interventionType: null,
    workflow: null,
    isRequeryDialogOpen: false,
    pendingDeletePartId: null,
    pendingUpdateStatusPartId: null,
    isCancelPartRequeryDialogOpen: false,
    isDialogOpenQuantityWarning: false,
    quantityWarningInfo: null,
    quantityWarningPendingAction: null,
    isStockExceededConfirmOpen: false,
    stockExceededPendingAction: null,
    extensionDays: null,
    isExtendDialogOpen: false,
    selectedOrderPart: null,
    isHistoryDialogOpen: false,
    historyDialogData: []
  } as IOrderDetailsState;

  public componentDidMount() {
    this.setState(
      {
        isLoadingOrderDetails: true
      },
      async () => {
        await this.loadData();
      }
    );

    this.refreshService
      .OrdersToRefresh$()
      .pipe(takeUntil(this.destroy))
      .subscribe((orderIds: number[]) => {
        if (orderIds.includes(this.props.orderDetails.id)) {
          this.setState(
            {
              isLoadingOrderDetails: true
            },
            async () => {
              await this.loadData();
            }
          );
        }
      });
  }

  public componentWillUnmount(): void {
    this.destroy.next();
  }

  loadData = async () => {
    const refOrderStatus = Referentials.referential.find(
      (item) => item.code === ReferentialCode.OrderStatus
    );
    const refOrderPartStatus = Referentials.referential.find(
      (item) => item.code === ReferentialCode.OrderPartStatus
    );
    const ref = Referentials.referential.find(
      (item) => item.code === ReferentialCode.AttachmentType
    );
    const refQualityPart = Referentials.referential.find(
      (item) => item.code === ReferentialCode.CarPartCategory
    );

    const orderParts = this.props.orderDetails.orderParts;
    const workflowId =
      this.props.caseSettingsState?.caseSettings?.workflow.id ??
      this.props.orderDetails.case?.caseWorkflow?.workflowId;
    const [
      orderStatus,
      orderPartStatus,
      statusHist,
      attachmentTypes,
      caseEvent,
      partQualityTypes,
      casePartToBeOrdered,
      suppliersInit,
      workflow
    ] = await Promise.all([
      this.appReferentialService.Get(refOrderStatus!.baseUrl),
      this.appReferentialService.Get(refOrderPartStatus!.baseUrl),
      this.orderService.GetOrderStatusHistories(this.props.orderDetails.id),
      this.appReferentialService.Get(ref!.baseUrl),
      this.caseService.GetCurrentEvent(this.props.orderDetails.caseId),
      this.appReferentialService.Get(refQualityPart!.baseUrl),
      orderParts && orderParts.length > 0
        ? this.orderService.GetPartToBeOrdered(orderParts[0].casePartToBeOrderedId)
        : null,
      !this.props.orderDetails.supplier
        ? this.organizationService.GetUserOrganizationsByIds([this.props.orderDetails.supplierId])
        : [],
      workflowId ? this.workflowService.GetUserWorkflow(workflowId) : null
    ]);

    if (!this.props.orderDetails.supplier) {
      const supplier = suppliersInit.find((item) => item.id === this.props.orderDetails.supplierId);
      this.props.orderDetails.supplier = supplier === undefined ? null : supplier;
    }

    const modelId =
      this.props.caseSettingsState?.case?.caseVehicle?.modelId ??
      this.props.orderDetails?.caseVehicle?.modelId;
    const model = modelId ? await this.caseService.GetModelById(modelId) : null;

    const [users] = await Promise.all([
      this.appUserService.GetUsersInfo(
        Array.from(new Set(statusHist.map((item) => item.createdBy)))
      )
    ]);

    statusHist.forEach((p) => {
      const user = users.find((item) => item.id === p.createdBy);
      p.createdByUser = user === undefined ? null : user;
    });

    let partsLocationOrganization = null;
    if (!isNullOrUndefined(this.props.orderDetails.partsLocationOrganizationId)) {
      partsLocationOrganization = await this.organizationService.GetOrganization(
        this.props.orderDetails.partsLocationOrganizationId!
      );
    }

    let costCenter = null;
    if (!R.isNil(caseEvent)) {
      if (!isNullOrUndefined(caseEvent.organizationId)) {
        costCenter = await this.workflowService.GetCostCenter(caseEvent.organizationId!);
      }
    }
    let orgList: Organization[] = [];
    if (!isNullOrUndefined(this.props.caseSettingsState.case)) {
      orgList = await this.organizationService.GetOrganizationsByHO(
        this.props.caseSettingsState.case!.organizationOwnerId,
        null
      );
    }
    const showOrderPrice =
      !this.props.appState.appUser!.organization!.organizationType!.hideOrderPrices;
    let TVA = '0';
    if (this.props.orderDetails.amountWithoutTVA !== 0) {
      TVA = (
        (this.props.orderDetails.amountTVA / this.props.orderDetails.amountWithoutTVA) *
        100
      ).toFixed(0);
    } else {
      const caseParameterHistory = await this.caseService.GetCaseParameterHistory(
        this.props.orderDetails.caseId
      );
      const tvaParam = caseParameterHistory.find(
        (item) => item.parameterCode === ParametreCode.TVA
      );
      if (tvaParam) {
        TVA = tvaParam.value;
      }
    }

    const startCode =
      this.props.appState.appUser!.organization!.organizationType!.code ===
      OrganizationTypeCode.SUPPLIER
        ? OrderStatusTypesCode.FZR
        : OrderStatusTypesCode.REP;

    const orderPartStatusFiltered = orderPartStatus.filter((item) => item.isActive === true);
    const x = this.props.orderDetails.orderParts!.map((item) => {
      return { ...item } as OrderPartDTO;
    });
    for (let i = 0; i < x.length; i++) {
      x[i].isLoading = false;
      x[i].alternativeParts = [];
      x[i].hasEmptyGuideNumber = this.isEmpty(x[i].guideNumber);
      x[i].hasEmptyAlternativeGuideNumber = this.isEmpty(x[i].alternativeGuideNumber ?? '');
    }

    const hasSupplierRole = this.hasRight(RoleClaimsEnum.Supplier);
    this.setState({
      userStartCode: startCode,
      orderpartsList: x,
      statuses: orderStatus.filter((item) => item.isActive === true),
      orderStatuses: orderStatus.filter((item) => item.isActive === true),
      orderPartStatus: orderPartStatusFiltered,
      selectedDisplayedStatus: !isNullOrUndefined(statusHist[0].orderStatus)
        ? statusHist[0].orderStatus.displayName
        : '',
      selectedStatus: statusHist[0].orderStatus!,
      orderStatusHistory: statusHist,
      TVA: TVA,
      isLoadingOrderDetails: false,
      attachType: attachmentTypes.find((item) => item.code === AttachmentTypeCode.OTHER)!,
      partsLocationOrganization: partsLocationOrganization,
      organizations: orgList,
      showOrderPrice: showOrderPrice,
      costCenter: costCenter,
      quality:
        partQualityTypes.find(
          (item) => item.id === this.props.orderDetails.supplier?.categoryPartId
        ) ?? null,
      rowsExpanded:
        this.props.orderDetails.orderStatus?.code === OrderStatusCode.REP_VERIFICATA_DE_FURNIZOR &&
        !hasSupplierRole
          ? (x
              .map((row, index) => (row.hasBeenVerifiedBySupplier ? index : null))
              .filter((index) => index !== null) as number[])
          : [],
      hasSupplierRole: hasSupplierRole,
      firstCasePartToBeOrdered: casePartToBeOrdered,
      model: model,
      interventionType: !R.isNil(caseEvent) ? caseEvent.interventionType : null,
      workflow: workflow
    });
  };

  isEmpty = (value: string) => value == null || /^ *$/.test(value);

  public hasRight = (right: string): boolean => {
    return this.props.appState!.user!.profile.role.includes(right);
  };

  displayOtherOrderDetails = (value: any, row: any) => {
    const orderPart = this.state.orderpartsList.find((item) => item.id === row[0]);
    return (
      <Tooltip
        {...rest}
        title={
          <div>
            <div>
              {this.translatorService.Tranlate('ORDER_PART_DETAILS_STOCK_LABEL', 'Disponibil') +
                ': ' +
                (orderPart!.alternativePartQualityId === null
                  ? orderPart!.availableStock
                  : orderPart!.availableQuantity === null
                  ? ''
                  : orderPart!.availableQuantity)}
            </div>
            <div>
              {this.translatorService.Tranlate('ORDER_PART_DETAILS_LOCATION_LABEL', 'Locatie') +
                ': ' +
                (orderPart!.alternativePartQualityId === null
                  ? this.isNull(orderPart!.location, '')
                  : this.isNull(orderPart!.alternativePartStockLocation, ''))}
            </div>
          </div>
        }
      >
        <div>
          <span>{(isNullOrUndefined(value) || value === '' ? 'N/A' : value) + ' '}</span>
          <FontAwesomeIcon icon={['fas', 'info-circle']} />
        </div>
      </Tooltip>
    );
  };

  isNull = (value: any, nullValue: any) => {
    if (isNullOrUndefined(value)) {
      return nullValue;
    }

    return value;
  };

  displayDeliveryOrderDetails = (value: any, row: any) => {
    const orderPart = this.state.orderpartsList.find((item) => item.id === row[0]);
    return (
      <Box component="div">
        {isNullOrUndefined(orderPart!.deliveryTime) ? '' : orderPart!.deliveryTime}
        {!isNullOrUndefined(orderPart?.prevVal) && (
          <Box component="div">
            {this.translatorService.Tranlate(
              'ORDER_PART_DETAILS_DELIVERY_TIME_LABEL11',
              'Livrare valoare anterioara'
            ) +
              ': ' +
              (isNullOrUndefined(orderPart!.prevVal?.deliveryTime)
                ? ''
                : orderPart!.prevVal?.deliveryTime)}
          </Box>
        )}
      </Box>
    );
  };

  handleOECodeChange = (event: React.ChangeEvent<HTMLInputElement>, orderPart: OrderPart) => {
    const orderParts = [...this.state.orderpartsList];
    const index = orderParts.findIndex((item) => item.id === orderPart.id);
    if (index !== -1) {
      const updatedOrderPart = {
        ...orderParts[index],
        toBeUpdated: true,
        guideNumber: event.target.value,
        // Reset fields when guideNumber is changed
        alternativePartQualityId: null,
        originalPrice: 0,
        producer: null,
        deliveryTime: null,
        validityTime: null,
        codeType: null,
        excludeFromOrder: null,
        orderCode: null,
        type: null,
        locationId: null,
        availableStock: null,
        location: null,
        remarks: null,
        alternativeGuideNumber: null,
        alternativePartCode: null,
        alternativePrice: 0,
        alternativePartStockQuantity: null,
        alternativePartStockLocation: null,
        alternativePartRemarks: null,
        productId: null,
        codEan: null,
        bundleItem: null,
        bundleNo: null,
        bundleQuantity: null,
        availableQuantity: null,
        supplierId: null,
        hasBeenVerifiedBySupplier: true,
        byOeCode: true
      };
      // Update the orderParts list
      orderParts[index] = updatedOrderPart;

      //Delete grouped parts
      const orderPart = orderParts[index];
      if (orderPart.groupedUniqueId !== null) {
        for (let i = 0; i < orderParts.length; i++) {
          if (
            orderPart.groupedUniqueId === orderParts[i].groupedUniqueId &&
            orderPart.id !== orderParts[i].id
          ) {
            orderParts[i].isDeleted = true;
            orderParts[i].toBeDeleted = true;
            orderParts[i].hasBeenVerifiedBySupplier = true;
          }
        }
      }
      // Set the updated state
      this.setState(
        {
          orderpartsList: orderParts
        },
        () => {
          this.updateAmount();
        }
      );
    }
  };

  handleAMCodeChange = (event: React.ChangeEvent<HTMLInputElement>, orderPart: OrderPart) => {
    const orderParts = [...this.state.orderpartsList];
    const index = orderParts.findIndex((item) => item.id === orderPart.id);

    if (index !== -1) {
      const updatedOrderPart = {
        ...orderParts[index],
        toBeUpdated: true,
        alternativeGuideNumber: event.target.value,
        // Reset fields when guideNumber is changed
        alternativePartQualityId: null,
        originalPrice: 0,
        producer: null,
        deliveryTime: null,
        validityTime: null,
        codeType: null,
        excludeFromOrder: null,
        orderCode: null,
        type: null,
        locationId: null,
        availableStock: null,
        location: null,
        remarks: null,
        alternativePartCode: null,
        alternativePrice: 0,
        alternativePartStockQuantity: null,
        alternativePartStockLocation: null,
        alternativePartRemarks: null,
        productId: null,
        codEan: null,
        bundleItem: null,
        bundleNo: null,
        bundleQuantity: null,
        availableQuantity: null,
        supplierId: null,
        hasBeenVerifiedBySupplier: true,
        byOeCode: false
      };

      // Update the orderParts list
      orderParts[index] = updatedOrderPart;

      //Delete grouped parts
      const orderPart = orderParts[index];
      if (orderPart.groupedUniqueId !== null) {
        for (let i = 0; i < orderParts.length; i++) {
          if (
            orderPart.groupedUniqueId === orderParts[i].groupedUniqueId &&
            orderPart.id !== orderParts[i].id
          ) {
            orderParts[i].isDeleted = true;
            orderParts[i].toBeDeleted = true;
            orderParts[i].hasBeenVerifiedBySupplier = true;
          }
        }
      }
      // Set the updated state
      this.setState(
        {
          orderpartsList: orderParts
        },
        () => {
          this.updateAmount();
        }
      );
    }
  };

  handlePieceNrChange = (e: React.ChangeEvent<HTMLInputElement>, orderPart: OrderPart) => {
    const newValue = isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value);

    if (newValue >= 10) {
      this.setState({
        isDialogOpenQuantityWarning: true,
        quantityWarningInfo: { quantity: newValue },
        quantityWarningPendingAction: () => this.applyPieceNrChange(newValue, orderPart)
      });
      return;
    }

    this.applyPieceNrChange(newValue, orderPart);
  };

  applyPieceNrChange = (newValue: number, orderPart: OrderPart) => {
    const orderParts = [...this.state.orderpartsList];
    const index = orderParts.findIndex((item) => item.id === orderPart.id);

    if (index !== -1) {
      const updatedOrderPart = {
        ...orderParts[index],
        pieceNr: newValue
      };
      // Update the orderParts list
      orderParts[index] = updatedOrderPart;

      if (orderParts[index].alternativeParts && orderParts[index].alternativeParts.length > 0) {
        orderParts[index] = {
          ...orderParts[index],
          alternativeGuideNumber: null,
          alternativePartCode: null,
          alternativePrice: null,
          alternativePartStockQuantity: null,
          alternativePartStockLocation: null,
          alternativePartRemarks: null,
          alternativePartQualityId: null,
          producer: null,
          deliveryTime: null,
          minQty: 0,
          bundleItem: null,
          bundleNo: null,
          bundleQuantity: null,
          availableQuantity: null,
          supplierId: null,
          alternativeParts: []
        };

        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'REINTEROGATE_ALTERNATIVE_PARTS_QTY',
            'Cantitatea a fost modificată, vă rugăm să reinterogați piesa!'
          ),
          {
            variant: 'warning',
            autoHideDuration: 6000
          }
        );

        this.setState(
          {
            orderpartsList: orderParts
          },
          () => {
            this.updateAmount();
          }
        );
        return;
      }

      const caseCalculationAlternativePartCopy = [...orderParts[index].alternativeParts];
      const alternativePartChecked = caseCalculationAlternativePartCopy.find(
        (item) =>
          item.originalPartId === orderParts[index].id &&
          item.selectedAlternativePart !== 9999999999999
      );

      if (!R.isNil(alternativePartChecked)) {
        const currentPacking = alternativePartChecked.packing?.split('|')[0];
        const secondItemOfPacking = alternativePartChecked.packing?.split('|')[1];
        if (currentPacking && secondItemOfPacking) {
          const currentPackingNumber = parseFloat(currentPacking);
          if (newValue % currentPackingNumber != 0 || newValue < alternativePartChecked.minQty) {
            this.props.enqueueSnackbar(
              this.translatorService.Tranlate(
                'MIN_PACKING_ERROR_MSG',
                'Cantitatea comandata trebuie sa fie '
              ) +
                currentPackingNumber +
                this.translatorService.Tranlate(
                  'MIN_PACKING_MULTIPLE_ERROR_MSG',
                  ' sau multiplul acesteia!'
                ),
              { variant: 'warning', autoHideDuration: 5000 }
            );
          }
        } else if (newValue < alternativePartChecked.minQty) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate(
              'MIN_PACKING_ERROR_MSG',
              'Cantitatea comandata trebuie sa fie '
            ) +
              alternativePartChecked.minQty +
              this.translatorService.Tranlate(
                'MIN_PACKING_MULTIPLE_ERROR_MSG',
                ' sau multiplul acesteia!'
              ),
            { variant: 'warning', autoHideDuration: 5000 }
          );
        }
        if (
          !R.isNil(alternativePartChecked!.availableQuantity) &&
          alternativePartChecked!.availableQuantity < newValue
        ) {
          this.validateOrigPartUnitsAdd(orderParts[index].id);
        } else {
          this.validateOrigPartUnitsRemove(orderParts[index].id);
        }
      }

      // Set the updated state
      this.setState(
        {
          orderpartsList: orderParts
        },
        () => {
          this.updateAmount();
        }
      );
    }
  };

  validateOrigPartUnitsAdd = (originalPartid: number) => {
    const labelParent = document.getElementsByClassName('id-' + originalPartid)[0] as HTMLElement;
    const identifylabel = labelParent.firstChild as any;
    const labelValidate = identifylabel.classList.add('Mui-error');

    const inputParent = document
      .getElementsByClassName('id-' + originalPartid)[0]
      .closest('div') as HTMLElement;
    const inputElement = inputParent.querySelector('input') as HTMLInputElement;
    const inputValidate = inputElement.classList.add('text-danger');

    return labelValidate && inputValidate;
  };

  validateOrigPartUnitsRemove = (originalPartid: number) => {
    const labelParent = document.getElementsByClassName('id-' + originalPartid)[0] as HTMLElement;
    const identifylabel = labelParent.firstChild as any;
    const labelValidate = identifylabel.classList.remove('Mui-error');

    const inputParent = document
      .getElementsByClassName('id-' + originalPartid)[0]
      .closest('div') as HTMLElement;
    const inputElement = inputParent.querySelector('input') as HTMLInputElement;
    const inputValidate = inputElement.classList.remove('text-danger');

    return labelValidate && inputValidate;
  };

  viewDeletePart = (): boolean => {
    const currentStatus = this.getStatusValue();
    if (
      currentStatus?.code === OrderStatusCode.REP_DRAFT ||
      currentStatus?.code === OrderStatusCode.REP_REINTEROGATED_PARTS
    ) {
      return true;
    }

    if (
      currentStatus?.code === OrderStatusCode.REP_VERIFICATA_DE_FURNIZOR &&
      this.state.rowsExpanded.length == 0
    ) {
      return true;
    }

    return false;
  };

  handleClientOECodeChange = (event: React.ChangeEvent<HTMLInputElement>, orderPart: OrderPart) => {
    const orderParts = [...this.state.orderpartsList];
    const index = orderParts.findIndex((item) => item.id === orderPart.id);
    if (index !== -1) {
      const updatedOrderPart = {
        ...orderParts[index],
        guideNumber: event.target.value
      };
      // Update the orderParts list
      orderParts[index] = updatedOrderPart;

      // Set the updated state
      this.setState({
        orderpartsList: orderParts
      });
    }
  };

  handleClientAMCodeChange = (event: React.ChangeEvent<HTMLInputElement>, orderPart: OrderPart) => {
    const orderParts = [...this.state.orderpartsList];
    const index = orderParts.findIndex((item) => item.id === orderPart.id);
    if (index !== -1) {
      const updatedOrderPart = {
        ...orderParts[index],
        alternativeGuideNumber: event.target.value
      };
      // Update the orderParts list
      orderParts[index] = updatedOrderPart;

      // Set the updated state
      this.setState({
        orderpartsList: orderParts
      });
    }
  };

  getPartsByColumns = (): MUIDataTableColumnDef[] => {
    const currentStatus = this.getStatusValue();
    const orderParts = new OrderParts(this.state.orderpartsList, 0);
    const columns = [
      {
        name: 'id',
        options: {
          /*display: 'excluded',*/
          filter: false
        } as MUIDataTableColumnOptions
      },
      {
        name: 'guideNumber',
        label: this.translatorService.Tranlate('ORDER_PART_DETAILS_OE_CODE_LABEL', 'Cod OE'),
        options: {
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            const part = this.state.orderpartsList.find((item) => item.id === tableMeta.rowData[0]);
            if (part === null) {
              return;
            }

            if (currentStatus?.code === OrderStatusCode.FZR_VERIFICARE_LA_FURNIZOR) {
              if (
                !R.isNil(this.state.quality) &&
                this.state.quality.code === CarPartQualityTypeCode.OE &&
                this.state.hasSupplierRole
              ) {
                return (
                  <TextField
                    name="guideNumber"
                    type="text"
                    value={part!.guideNumber}
                    fullWidth
                    style={{ minWidth: '80px' }}
                    onChange={(e: any) => this.handleOECodeChange(e, part!)}
                    disabled={part!.excludeFromOrder ?? false}
                  />
                );
              }
            }

            if (
              !R.isNil(this.state.quality) &&
              this.state.quality.code === CarPartQualityTypeCode.OE &&
              part!.hasEmptyGuideNumber
            ) {
              return (
                <TextField
                  name="guideNumber"
                  type="text"
                  value={part!.guideNumber}
                  fullWidth
                  style={{ minWidth: '80px' }}
                  onChange={(e: any) => this.handleClientOECodeChange(e, part!)}
                  disabled={part!.excludeFromOrder ?? false}
                />
              );
            }

            return part!.guideNumber;
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'alternativeGuideNumber',
        label: this.translatorService.Tranlate(
          'ORDER_PART_DETAILS_SUPPLIER_CODE_LABEL',
          'Cod Furnizor'
        ),
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            const part = this.state.orderpartsList.find((item) => item.id === tableMeta.rowData[0]);
            if (part === null) {
              return;
            }
            const currentStatus = this.getStatusValue();
            if (currentStatus?.code === OrderStatusCode.FZR_VERIFICARE_LA_FURNIZOR) {
              if (
                !R.isNil(this.state.quality) &&
                this.state.quality.code === CarPartQualityTypeCode.AM &&
                this.state.hasSupplierRole
              ) {
                return (
                  <TextField
                    name="alternativeGuideNumber"
                    type="text"
                    value={part!.alternativeGuideNumber}
                    fullWidth
                    style={{ minWidth: '80px' }}
                    onChange={(e: any) => this.handleAMCodeChange(e, part!)}
                    disabled={part!.excludeFromOrder ?? false}
                  />
                );
              }
            }

            if (
              !R.isNil(this.state.quality) &&
              this.state.quality.code === CarPartQualityTypeCode.AM &&
              part!.hasEmptyAlternativeGuideNumber
            ) {
              return (
                <TextField
                  name="alternativeGuideNumber"
                  type="text"
                  value={part!.alternativeGuideNumber}
                  fullWidth
                  style={{ minWidth: '80px' }}
                  onChange={(e: any) => this.handleClientAMCodeChange(e, part!)}
                  disabled={part!.excludeFromOrder ?? false}
                />
              );
            }

            return part!.alternativeGuideNumber;
          }
        }
      },
      {
        name: 'name',
        label: this.translatorService.Tranlate('ORDER_PART_DETAILS_NAME_LABEL', 'Denumire'),
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            const part = this.state.orderpartsList.find((item) => item.id === tableMeta.rowData[0]);

            if (this.state.hasSupplierRole && part?.alternativePartDescription) {
              return part!.alternativePartDescription;
            }

            if (!isNullOrUndefined(part!.alternativePartQualityId)) {
              return part!.alternativePartName;
            }

            return part!.name;
          }
        }
      },
      {
        name: 'carPartCategory.displayName',
        label: this.translatorService.Tranlate('ORDER_PART_DETAILS_QUALITY_LABEL', 'Calitate'),
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            const part = this.state.orderpartsList.find((item) => item.id === tableMeta.rowData[0]);
            if (part!.alternativePartQualityId === null) {
              return part!.carPartCategory!.displayName;
            } else {
              if (isNullOrUndefined(part!.alternativePartQuality)) {
                return '';
              }
              return part!.alternativePartQuality.displayName;
            }
          }
        }
      },
      {
        name: 'originalPrice',
        label: this.translatorService.Tranlate(
          'ORDER_PART_DETAILS_ORIGINAL_PRICE_LABEL',
          'Pret unitar'
        ),
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            const part = this.state.orderpartsList.find((item) => item.id === tableMeta.rowData[0]);
            const order = this.props.orderDetails;

            if (
              !isNullOrUndefined(part?.prevVal) &&
              pretUnitarFormat(
                part!.prevVal,
                part!.prevVal!.originalPrice,
                this.props.orderDetails.currencyCode,
                this.props.appState.appUser?.organization?.country ?? null
              ) !==
                pretUnitarFormat(
                  part,
                  value,
                  this.props.orderDetails.currencyCode,
                  this.props.appState.appUser?.organization?.country ?? null
                )
            ) {
              return (
                <React.Fragment>
                  <TextField
                    label={
                      'Valoare Anterioara: ' +
                      pretUnitarFormat(
                        part!.prevVal,
                        part!.prevVal!.originalPrice,
                        this.props.orderDetails.currencyCode,
                        this.props.appState.appUser?.organization?.country ?? null
                      )
                    }
                    disabled
                    value={
                      pretUnitarFormat(
                        part,
                        value,
                        this.props.orderDetails.currencyCode,
                        this.props.appState.appUser?.organization?.country ?? null
                      ) || ''
                    }
                    style={{ border: 'red' }}
                  />
                </React.Fragment>
              );
            }
            return this.state.showOrderPrice
              ? pretUnitarFormat(
                  part,
                  value,
                  this.props.orderDetails.currencyCode,
                  this.props.appState.appUser?.organization?.country ?? null
                )
              : '';
          }
        }
      },
      {
        name: 'pieceNr',
        label: this.translatorService.Tranlate('ORDER_PART_DETAILS_PIECE_NR_LABEL', 'Unitati'),
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            const part = this.state.orderpartsList.find((item) => item.id === tableMeta.rowData[0]);
            if (!isNullOrUndefined(part?.prevVal) && part?.prevVal.pieceNr !== value) {
              return (
                <React.Fragment>
                  <TextField
                    label={'Valoare Anterioara: ' + part?.prevVal.pieceNr}
                    disabled
                    value={value || ''}
                    style={{ border: 'red' }}
                  />
                </React.Fragment>
              );
            }
            if (
              currentStatus?.code === OrderStatusCode.REP_VERIFICATA_DE_FURNIZOR &&
              !this.state.hasSupplierRole &&
              part!.hasBeenVerifiedBySupplier
            ) {
              return (
                <TextField
                  name="quantity"
                  id="quantity"
                  className={`mr-3 id-${part!.id}`}
                  type="number"
                  InputProps={{ inputProps: { min: 1 } }}
                  value={part!.pieceNr}
                  fullWidth
                  style={{ minWidth: '80px' }}
                  onChange={(e: any) => this.handlePieceNrChange(e, part!)}
                  disabled={part!.excludeFromOrder ?? false}
                />
              );
            }
            return value;
          }
        }
      },
      {
        name: 'discount',
        label: this.translatorService.Tranlate('ORDER_PART_DETAILS_DISCOUNT_LABEL', 'Discount (%)'),
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            const part = this.state.orderpartsList.find((item) => item.id === tableMeta.rowData[0]);

            if (part!.alternativePartQualityId === null) {
              return part!.discount;
            } else {
              return part!.alternativePartDiscount;
            }
          }
        }
      },
      {
        name: '',
        label: this.translatorService.Tranlate(
          'ORDER_PART_DETAILS_TOTAL_PRICE_LABEL',
          'Pret total'
        ),
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            const part = this.state.orderpartsList.find((item) => item.id === tableMeta.rowData[0]);
            const totalPrice = orderParts.getTotalPrice(part!);
            return this.state.showOrderPrice
              ? Utils.countryNumberFormat(
                  totalPrice.toFixed(2),
                  this.props.appState.appUser?.organization?.country ?? null
                ) +
                  ' ' +
                  (!isNullOrUndefined(this.props.orderDetails.currencyCode) &&
                  this.props.orderDetails.currencyCode !== ''
                    ? this.props.orderDetails.currencyCode
                    : '')
              : '';
          }
        }
      },
      {
        name: 'producer',
        label: this.translatorService.Tranlate('ORDER_PART_DETAILS_PRODUCER_LABEL', 'Producator'),
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value: any, tableMeta: MUIDataTableMeta) => {
            return this.displayOtherOrderDetails(value, tableMeta.rowData);
          }
        }
      },
      {
        name: 'remarks',
        label: this.translatorService.Tranlate('ORDER_PART_DETAILS_DELIVERY_TIME_LABEL', 'Livrare'),
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            return this.displayDeliveryOrderDetails(value, tableMeta.rowData);
          }
        }
      },
      {
        name: 'expectedDeliveryDate',
        label: this.translatorService.Tranlate(
          'ORDER_PART_EXPECTED_DELIVERY_LABEL',
          'Data livrare'
        ),
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value: any, tableMeta: MUIDataTableMeta) => {
            const part = this.state.orderpartsList.find((item) => item.id === tableMeta.rowData[0]);
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <span>
                  {part?.expectedDeliveryDate
                    ? this.formatDeliveryDate(part.expectedDeliveryDate)
                    : ''}
                </span>
                {part?.expectedDeliveryDate && (
                  <Tooltip
                    title={this.translatorService.Tranlate(
                      'ORDER_PART_DELIVERY_HISTORY_LABEL',
                      'Istoric livrare'
                    )}
                  >
                    <IconButton
                      size="small"
                      color="inherit"
                      onClick={() => this.handleOpenHistory(part!.id)}
                    >
                      <HistoryIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            );
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        label: this.translatorService.Tranlate(
          'ORDER_PART_DETAILS_DELIVERY_NOTICE_LABEL',
          'Nr. aviz'
        ),
        options: {
          display: this.isDisplayInvoiceColumn() ? 'true' : 'false',
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            const partId = tableMeta.rowData[0];
            const part = this.state.orderpartsList.find((item) => item.id === partId);
            if (part == null) {
              return;
            }
            return part!.processedDeliveryNotices ?? '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        label: this.translatorService.Tranlate(
          'ORDER_PART_DETAILS_INVOICE_NUMBER_LABEL',
          'Factura AI'
        ),
        options: {
          display: this.isDisplayInvoiceColumn() ? 'true' : 'false',
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            const partId = tableMeta.rowData[0];
            const part = this.state.orderpartsList.find((item) => item.id === partId);
            if (part == null) {
              return;
            }
            return part!.processedInvoiceNumbers ?? '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        label: this.translatorService.Tranlate('ORDER_PART_DETAILS_STATUS_LABEL', 'Status'),
        options: {
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            const partId = tableMeta.rowData[0];
            const part = this.state.orderpartsList.find((item) => item.id === partId);
            if (part == null) {
              return;
            }
            return part!.status!.displayName;
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            const id = tableMeta.rowData[0];
            const part = this.state.orderpartsList.find((item) => item.id === id);
            if (part!.isDeleted) {
              return (
                <span className="text-danger">
                  {this.translatorService.Tranlate('ORDER_PART_DETAILS_DELETED_LABEL', 'Sters')}
                </span>
              );
            }

            if (this.props.orderDetails.clientId !== this.props.appState.appUser!.organizationId) {
              return '';
            }

            return (
              this.viewDeletePart() && (
                <IconButton
                  onClick={(e) => this.deleteOrderPart(e, tableMeta)}
                  aria-label="delete"
                  color="inherit"
                  hidden={!this.props.hasRights}
                  className="text-danger"
                  size="small"
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              )
            );
          }
        }
      },
      {
        name: '',
        label: this.translatorService.Tranlate('ORDER_PART_ACTIONS_LABEL', 'Actiuni'),
        options: {
          display: this.isDeliveryActionsVisible() ? 'true' : 'excluded',
          filter: false,
          sort: false,
          customBodyRender: (value: any, tableMeta: MUIDataTableMeta) => {
            const partId = tableMeta.rowData[0];
            const part = this.state.orderpartsList.find((item) => item.id === partId);
            if (!part) return null;

            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip
                  title={this.translatorService.Tranlate(
                    'ORDER_PART_EXTEND_DELIVERY_LABEL',
                    'Prelungire livrare'
                  )}
                >
                  <IconButton
                    size="small"
                    color="inherit"
                    disabled={
                      !this.canUpdateOrderPartStatus(part) ||
                      isNullOrUndefined(part.expectedDeliveryDate)
                    }
                    onClick={() => {
                      this.setState({
                        isExtendDialogOpen: true,
                        selectedOrderPart: part,
                        extensionDays: null
                      });
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={this.translatorService.Tranlate(
                    'ORDER_PART_MARK_DELIVERED_LABEL',
                    'Marcat livrat'
                  )}
                >
                  <IconButton
                    size="small"
                    style={{ color: this.canUpdateOrderPartStatus(part) ? 'green' : undefined }}
                    disabled={!this.canUpdateOrderPartStatus(part)}
                    onClick={() => this.handleMarkAsDelivered(partId)}
                  >
                    <CheckCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={this.translatorService.Tranlate(
                    'ORDER_PART_CANCEL_LABEL',
                    'Anuleaza piesa'
                  )}
                >
                  <IconButton
                    size="small"
                    style={{ color: this.canUpdateOrderPartStatus(part) ? 'red' : undefined }}
                    disabled={!this.canUpdateOrderPartStatus(part)}
                    onClick={() =>
                      this.setState({
                        isCancelPartRequeryDialogOpen: true,
                        pendingUpdateStatusPartId: partId
                      })
                    }
                  >
                    <CancelOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </div>
            );
          }
        } as MUIDataTableColumnOptions
      }
    ];

    return columns;
  };

  closeDialog = async () => {
    this.setState({ isChangeOrderStatusDialogOpen: false });
  };

  closeExtendDialog = () => {
    this.setState({ isExtendDialogOpen: false });
  };

  closeHistoryDialog = () => {
    this.setState({ isHistoryDialogOpen: false });
  };

  getStatusValue = () => {
    let statusValue: IReferential | null = this.props.orderDetails.orderStatus;
    if (this.state.orderStatusHistory && this.state.orderStatusHistory[0]) {
      statusValue = this.state.orderStatusHistory[0].orderStatus;
    }
    return statusValue;
  };

  isOrderDelivered = (): boolean => {
    return this.getStatusValue()?.code === OrderStatusCode.REP_LIVRATA;
  };

  isDeliveryActionsVisible = (): boolean => {
    const country = this.props.appState.appUser?.organization?.country?.code;
    if (country === CountryCodeEnum.CZ.toString()) {
      return false;
    }
    const code = this.getStatusValue()?.code;
    return code === OrderStatusCode.REP_PLASATA || code === OrderStatusCode.FZR_COMANDA_CONFIRMATA;
  };

  isDisplayInvoiceColumn = (): boolean => {
    const hasLivrataOrPartialLivrataPart = this.state.orderpartsList.some(
      (part) =>
        part.status?.code === OrderPartStatus.LIVRATA ||
        part.status?.code === OrderPartStatus.PARTIAL_LIVRATA
    );
    return hasLivrataOrPartialLivrataPart || this.isOrderDelivered();
  };

  changeOrderStatusClick = async () => {
    const currentStatus = this.getStatusValue();
    if (currentStatus?.code === OrderStatusCode.REP_VERIFICATA_DE_FURNIZOR) {
      const hasError = this.validateOrder();
      if (hasError) {
        return;
      }
    }

    this.setState({ isChangeOrderStatusDialogOpen: true });
  };

  getNextOrderStatus = (): IReferential | undefined => {
    const currentStatus = this.getStatusValue();
    if (currentStatus?.code === OrderStatusCode.REP_DRAFT) {
      return this.state.statuses.find((item) => item.code === OrderStatusCode.REP_PLASATA);
    }

    if (currentStatus?.code === OrderStatusCode.FZR_VERIFICARE_LA_FURNIZOR) {
      return this.state.statuses.find(
        (item) => item.code === OrderStatusCode.REP_VERIFICATA_DE_FURNIZOR
      );
    }

    if (currentStatus?.code === OrderStatusCode.REP_VERIFICATA_DE_FURNIZOR) {
      return this.state.rowsExpanded.length > 0
        ? this.state.statuses.find((item) => item.code === OrderStatusCode.REP_REINTEROGATED_PARTS)
        : this.state.statuses.find((item) => item.code === OrderStatusCode.REP_PLASATA);
    }

    if (currentStatus?.code === OrderStatusCode.REP_REINTEROGATED_PARTS) {
      return this.state.statuses.find((item) => item.code === OrderStatusCode.REP_PLASATA);
    }

    return undefined;
  };

  canChangeNextOrderStatus = () => {
    const currentStatus = this.getStatusValue();
    return (
      !this.props.hasRights ||
      !currentStatus?.code?.includes(this.state.userStartCode) ||
      !(this.getNextOrderStatus() != undefined)
    );
  };

  getOrderButton(): string | undefined {
    const currentStatus: IReferential | null = this.getStatusValue();
    if (
      currentStatus?.code == OrderStatusCode.REP_VERIFICATA_DE_FURNIZOR.toString() &&
      this.state.hasSupplierRole
    ) {
      return currentStatus?.displayName;
    }
    if (currentStatus?.code == 'REP_DRAFT') {
      return this.props.automatePlaceOrder
        ? this.translatorService.Tranlate('CASE_CAR_CALCULATIONS_CONFIRM_BUTTON', 'Confirma')
        : this.translatorService.Tranlate('ORDER_PART_PLACE_ORDER_LABEL', 'Lanseaza Comanda');
    } else {
      if (currentStatus?.code == OrderStatusCode.FZR_VERIFICARE_LA_FURNIZOR.toString()) {
        return this.translatorService.Tranlate('ORDER_DETAILS_SAVE_BUTTON', 'Salveaza');
      }

      if (currentStatus?.code == OrderStatusCode.REP_VERIFICATA_DE_FURNIZOR.toString()) {
        return this.state.rowsExpanded.length > 0
          ? this.translatorService.Tranlate('ORDER_DETAILS_SAVE_BUTTON', 'Salveaza')
          : this.translatorService.Tranlate('ORDER_PART_PLACE_ORDER_LABEL', 'Lanseaza Comanda');
      }

      if (currentStatus?.code == OrderStatusCode.REP_REINTEROGATED_PARTS.toString()) {
        return this.translatorService.Tranlate('ORDER_PART_PLACE_ORDER_LABEL', 'Lanseaza Comanda');
      }

      return currentStatus?.displayName;
    }
  }

  hideSaveButton = () => {
    const currentStatus: IReferential | null = this.getStatusValue();
    if (
      currentStatus?.code === OrderStatusCode.FZR_VERIFICARE_LA_FURNIZOR &&
      !this.state.hasSupplierRole
    ) {
      return true;
    }

    return false;
  };

  allPartsInterogated = () => {
    const currentStatus = this.getStatusValue();
    if (
      currentStatus?.code === OrderStatusCode.REP_VERIFICATA_DE_FURNIZOR &&
      !this.state.hasSupplierRole
    ) {
      const nonInterogatedParts = [...this.state.orderpartsList].filter(
        (orderPart) => orderPart.hasBeenVerifiedBySupplier && !orderPart.supplierId
      );
      console.log('nonInterogatedParts', nonInterogatedParts);
      if (nonInterogatedParts.length > 0) {
        return false;
      }
    }

    return true;
  };

  renderOrderDetailsSection = () => {
    const isDisabled = this.canChangeNextOrderStatus() || !this.allPartsInterogated();

    return (
      <Card>
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoadingOrderDetails} />
        </div>
        {!this.state.isLoadingOrderDetails ? (
          <CardContent className="p-3">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div className="d-flex align-items-center float-right mt-2">
                  <div className="ml-2">
                    <span className="font-weight-bold">
                      {this.translatorService.Tranlate(
                        'CALCULATION_DETAILS_VEHICAL_PLATE_NUMBER',
                        'Numar inmatriculare'
                      )}
                      {''}:
                    </span>{' '}
                    {!R.isNil(this.props.caseSettingsState.case)
                      ? this.props.caseSettingsState.case.caseVehicle.plateNumber
                      : this.props.orderDetails.caseVehicle.plateNumber}
                  </div>
                  <div className="ml-2">
                    <span className="font-weight-bold">
                      {this.translatorService.Tranlate('CALCULATION_DETAILS_VIN', 'VIN')}
                      {''}:
                    </span>{' '}
                    {!R.isNil(this.props.caseSettingsState.case)
                      ? this.props.caseSettingsState.case.caseVehicle.vin
                      : this.props.orderDetails.caseVehicle.vin}
                  </div>
                  <div className="ml-2">
                    <span className="font-weight-bold">
                      {this.translatorService.Tranlate(
                        'CALCULATION_DETAILS_VEHICAL_NUMBER_OF_KM',
                        'Numar kilometri'
                      )}
                      {''}:
                    </span>{' '}
                    {!R.isNil(this.props.caseSettingsState.case)
                      ? this.props.caseSettingsState.case.caseVehicle.numberOfKilometers
                      : this.props.orderDetails.caseVehicle.numberOfKilometers}
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <div className="d-flex align-items-center">
                  {this.hideSaveButton() ? null : (
                    <Button
                      onClick={(e) =>
                        this.props.automatePlaceOrder || this.props.workflowAutomatePlaceOrder
                          ? this.changeOrderStatusSubmit()
                          : this.changeOrderStatusClick()
                      }
                      className={`mr-2 ${!isDisabled ? 'bg-success-button' : ''}`}
                      variant="contained"
                      disabled={isDisabled}
                    >
                      {this.getOrderButton()}
                      {/*{this.state.selectedDisplayedStatus}*/}
                    </Button>
                  )}
                  <div className="text-black font-weight-bold">
                    <span>{this.props.orderDetails.id} </span>
                    <span title="Client">
                      {!isNullOrUndefined(this.props.orderDetails.client)
                        ? this.props.orderDetails.client.name
                        : ''}
                    </span>
                    <span
                      title={this.translatorService.Tranlate(
                        'ORDER_PART_DETAILS_SUPPLIER_LABEL',
                        'Furnizor'
                      )}
                    >
                      {!isNullOrUndefined(this.props.orderDetails.supplier)
                        ? ' - ' +
                          (this.props.orderDetails.supplier.name.toUpperCase() ==
                          OwnStockCodeEnum.OWN_STOCK.toString()
                            ? this.translatorService.Tranlate(
                                'CALCULATION_DETAILS_OWN_STOCK_HEADER',
                                'Stoc Propriu'
                              )
                            : this.props.orderDetails.supplier.name)
                        : ''}
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div className="align-items-center">
                  <div className="text-black font-weight-bold">
                    <span className="">
                      {!isNullOrUndefined(this.state.partsLocationOrganization)
                        ? this.translatorService.Tranlate(
                            'ORDER_PART_DETAILS_SUPPLIER_LABEL11',
                            'Adresa livrare:'
                          ) +
                          ' ' +
                          Utils.FormatFullDeliveryAddress(
                            this.state.partsLocationOrganization,
                            (k, d) => this.translatorService.Tranlate(k, d),
                            this.props.appState.appUser?.organization?.country ?? null
                          )
                        : ''}
                    </span>
                  </div>
                  <div className="text-black font-weight-bold">
                    <span className="">
                      {!isNullOrUndefined(this.state.costCenter)
                        ? this.translatorService.Tranlate(
                            'CASE_EVENT_COST_CENTER',
                            'Centru de cost'
                          ) +
                          ':' +
                          ' ' +
                          this.state.costCenter.name
                        : ''}
                    </span>
                  </div>
                  <div className="text-black font-weight-bold">
                    <span className="">
                      {!isNullOrUndefined(this.state.interventionType)
                        ? this.translatorService.Tranlate(
                            'CASE_EVENT_INTERVENTION_TYPE_LABEL',
                            'Tip Interventie'
                          ) +
                          ':' +
                          ' ' +
                          this.state.interventionType.displayName
                        : ''}
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div className="d-flex align-items-center float-right mt-2">
                  <div className="text-black-50 font-weight-bold">
                    <span>
                      {!isNullOrUndefined(this.props.orderDetails.createdByUser)
                        ? this.props.orderDetails.createdByUser.userName
                        : ''}{' '}
                    </span>
                    <span>
                      {moment
                        .utc(this.props.orderDetails.date)
                        .local()
                        .format(this.props.appState.longDateFormat)}
                    </span>
                  </div>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        ) : null}
      </Card>
    );
  };

  interogateAlternativeParts = async (orderPart: OrderPart, index: number) => {
    this.getInactiveWorkflowSuppliers();
    try {
      this.interogate(orderPart, index);
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  getInactiveWorkflowSuppliers = async () => {
    if (!this.state.workflow?.inactiveSupplierNotification) {
      return;
    }
    const inactiveSuppliers = await this.workflowService.GetWorkflowSuppliersByStatus({
      workflowId: this.state.workflow.id,
      organizationId:
        this.props.orderDetails.partsLocationOrganizationId ??
        this.props.appState.appUser!.organizationId!,
      isActive: false,
      supplierId: this.props.orderDetails.supplierId
    } as GetSuppliersByStatusRequestDto);

    if (inactiveSuppliers.length > 0) {
      this.props.enqueueSnackbar(
        (inactiveSuppliers.length == 1
          ? this.translatorService.Tranlate(
              'INACTIVE_SUPPLIERS_MSG_FIRST_PART_SINGLE',
              'Achizitia de la furnizorul'
            )
          : this.translatorService.Tranlate(
              'INACTIVE_SUPPLIERS_MSG_FIRST_PART_MULTIPLE',
              'Achizitia de la furnizorii'
            )) +
          ' ' +
          inactiveSuppliers.map((supplier) => supplier.supplierName).join(', ') +
          ' ' +
          (inactiveSuppliers.length == 1
            ? this.translatorService.Tranlate(
                'INACTIVE_SUPPLIERS_MSG_SECOND_PART_SINGLE',
                'este momentan blocată!'
              )
            : this.translatorService.Tranlate(
                'INACTIVE_SUPPLIERS_MSG_SECOND_PART_MULTIPLE',
                'sunt momentan blocate!'
              )),
        {
          variant: 'warning',
          autoHideDuration: 6000
        }
      );
    }
  };

  interogate = async (orderPart: OrderPart, index: number) => {
    this.setState(
      {
        orderpartsList: this.state.orderpartsList.map((item, itemIndex) =>
          itemIndex === index ? { ...item, isLoading: true } : item
        )
      },
      async () => {
        const alternativeParts =
          await this.caseService.InterogateCaseCalculationsAlternativePartsBySupplier({
            partId: orderPart.id,
            partNumber:
              !R.isNil(this.state.quality) && this.state.quality.code === CarPartQualityTypeCode.OE
                ? orderPart.guideNumber
                : orderPart.alternativeGuideNumber ?? '',
            addition: this.props.additionTariff.value,
            discount: this.props.discountTariff.value,
            workflowId:
              this.props.caseSettingsState?.caseSettings?.workflow.id ??
              this.props.orderDetails.case?.caseWorkflow?.workflowId,
            organizationId: this.props.orderDetails.partsLocationOrganizationId,
            supplierId: this.props.orderDetails.supplierId ?? 0,
            qty: orderPart.pieceNr
          } as GetSuppliersAlternativePartsRequestDto);

        [...alternativeParts].forEach((item, index) => {
          item.id = this.uuidToNumber();
        });

        const orderParts = [...this.state.orderpartsList];
        orderParts[index].alternativeParts = alternativeParts;
        orderParts[index].isLoading = false;

        this.setState({
          orderpartsList: orderParts
        });
      }
    );
  };

  uuidToNumber = (): number => {
    const uniqueId = uuid();
    const hexString = uniqueId.replace(/-/g, '');
    const numericValue = parseInt(hexString, 16);
    //number with 9 characters
    return numericValue % 1000000000;
  };

  handleAlternativePartChecked = (selected: number, id: number, partFromGroup: number) => {
    return selected === id || partFromGroup == id;
  };

  handleAlternativePartSelect = (
    id: number,
    orderPartIndex: number,
    originalPartid: number,
    alternativePart: CaseCalculationAlternativePart
  ) => {
    const orderParts = [...this.state.orderpartsList];

    const orderPart = {
      ...orderParts[orderPartIndex],
      ...mapAlternativePartToCalculationPart(
        alternativePart,
        orderParts[orderPartIndex].groupedUniqueId,
        alternativePart.excludeFromOrder
      ),
      toBeUpdated: true
    };
    orderParts[orderPartIndex] = orderPart;

    const currentPacking = orderPart.packing?.split('|')[0];
    const secondItemOfPacking = orderPart.packing?.split('|')[1];

    const specificAlternativeParts = [...orderPart.alternativeParts];
    const findAlternativePartGroup = _.filter(specificAlternativeParts, function (object) {
      return (
        object.bundleNo != null &&
        object.bundleNo == orderPart.bundleNo &&
        object.alternativePartCode != orderPart.alternativePartCode
      );
    });

    const idList: any = [];
    for (let i = 0; i < findAlternativePartGroup.length; i++) {
      idList.push(findAlternativePartGroup[i].id);
    }

    specificAlternativeParts.forEach((item) => {
      item.selectedAlternativePart =
        item.originalPartId === originalPartid
          ? item.id === id
            ? id
            : 9999999999999
          : item.selectedAlternativePart;
      item.partFromGroup =
        item.originalPartId === originalPartid
          ? idList.includes(item.id)
            ? item.id
            : 9999999999999
          : item.partFromGroup;
      if (
        item.originalPartId === originalPartid &&
        item.selectedAlternativePart !== 9999999999999
      ) {
        const initialCaseCalculationOriginalParts = {
          ...orderPart
        };
        orderPart.package = [];
        if (currentPacking && secondItemOfPacking) {
          const currentPackingNumber = parseFloat(currentPacking);
          if (
            orderPart.pieceNr % currentPackingNumber != 0 ||
            orderPart.pieceNr < orderPart.minQty
          ) {
            this.props.enqueueSnackbar(
              this.translatorService.Tranlate(
                'MIN_PACKING_ERROR_MSG',
                'Cantitatea comandata trebuie sa fie '
              ) +
                currentPackingNumber +
                this.translatorService.Tranlate(
                  'MIN_PACKING_MULTIPLE_ERROR_MSG',
                  ' sau multiplul acesteia!'
                ),
              { variant: 'warning', autoHideDuration: 5000 }
            );
          }
        } else if (orderPart.pieceNr < orderPart.minQty) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate(
              'MIN_PACKING_ERROR_MSG',
              'Cantitatea comandata trebuie sa fie '
            ) +
              orderPart.minQty +
              this.translatorService.Tranlate(
                'MIN_PACKING_MULTIPLE_ERROR_MSG',
                ' sau multiplul acesteia!'
              ),
            { variant: 'warning', autoHideDuration: 5000 }
          );
        }
        if (findAlternativePartGroup.length) {
          let displayPopup = true;
          let alternativePartString = '';
          for (let i = 0; i < findAlternativePartGroup.length; i++) {
            if (
              findAlternativePartGroup[i].alternativePartCode == AlternativeCode.TAXAMEDIU &&
              findAlternativePartGroup.length == 1
            ) {
              displayPopup = false;
            }
            alternativePartString +=
              findAlternativePartGroup[i].name +
              '(' +
              findAlternativePartGroup[i].alternativePrice +
              ' RON)' +
              '\n';
            orderPart.package.push({
              ...initialCaseCalculationOriginalParts,
              ...mapAlternativePartToCalculationPart(
                findAlternativePartGroup[i],
                orderPart.groupedUniqueId,
                true
              ),
              id: 0,
              originalPrice: 0,
              hasBeenVerifiedBySupplier: true
            });
          }
          if (displayPopup) {
            this.props.enqueueSnackbar(
              ' Componente adaugate la comanda: \n' + alternativePartString,
              {
                variant: 'warning',
                style: { whiteSpace: 'pre-line' },
                autoHideDuration: 5000
              }
            );
          }
        }

        if (!Number.isInteger(orderPart.pieceNr)) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate(
              'DECIMAL_ERROR_MSG',
              'Cantitatea comandata trebuie sa fie un numar intreg fara zecimale'
            ),
            {
              variant: 'warning',
              autoHideDuration: 5000
            }
          );
        }

      }
    });

    this.setState(
      {
        orderpartsList: orderParts
      },
      () => {
        this.updateAmount();
      }
    );
  };

  getPackageFromOrderParts = (orderParts: OrderPart[]) => {
    const newOrderParts = [];
    for (let i = 0; i < orderParts.length; i++) {
      if (orderParts[i].package && orderParts[i].package.length) {
        for (let j = 0; j < orderParts[i].package.length; j++) {
          newOrderParts.push(orderParts[i].package[j]);
        }
      }
    }
    return newOrderParts;
  };

  clearSelectedAlternativeParts = async (originalPartId: number, index: number) => {
    const orderPartsCopy = [...this.state.orderpartsList];
    let alternativePartsCopy = [...this.state.orderpartsList[index].alternativeParts];
    alternativePartsCopy = alternativePartsCopy.map((item) => {
      item.selectedAlternativePart =
        item.originalPartId === originalPartId ? 9999999999999 : item.selectedAlternativePart;
      item.partFromGroup =
        item.originalPartId === originalPartId ? 9999999999999 : item.partFromGroup;
      return item;
    });

    orderPartsCopy[index] = {
      ...orderPartsCopy[index],
      alternativeParts: alternativePartsCopy
    };

    this.setState({
      orderpartsList: orderPartsCopy
    });
  };

  renderExpandedRow = (rowData: any, rowMeta: any) => {
    const index = rowMeta.dataIndex;
    const orderPart = this.state.orderpartsList[index];
    const alternativeParts = orderPart.alternativeParts ?? [];
    // Calculate the number of columns in the table
    const columnsCount = this.getPartsByColumns().length + 2;

    return (
      <tr>
        <td colSpan={columnsCount}>
          <Box m={1} p={1} style={{ border: '1px solid #ddd', borderRadius: '4px' }}>
            <Button
              onClick={async (e) => {
                await this.interogateAlternativeParts(orderPart, index);
              }}
              className="float-right mb-3"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: MuiTheme.palette.primary.main,
                padding: '6px 16px',
                fontSize: '14px',
                minWidth: '64px',
                boxSizing: 'border-box',
                transition:
                  'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
                fontWeight: 'normal',
                lineHeight: '1.75',
                borderRadius: '0.5rem',
                letterSpacing: '0.02857em',
                textTransform: 'none'
              }}
            >
              {this.translatorService.Tranlate('INTEROGATE', 'Interogheaza')}
            </Button>

            <div className="table-responsive">
              <div className="d-flex flex-row text-center flex-wrap justify-content-center">
                <ScaleLoader color={'var(--primary)'} loading={orderPart.isLoading} />
              </div>

              {orderPart.isLoading ? null : (
                <div className="tableFixHead">
                  <table className="table table-striped table-hover table-bordered mb-4">
                    <thead
                      style={{
                        display: 'block',
                        width: '100%',
                        position: 'sticky',
                        top: '0',
                        backgroundColor: '#f8f9fa',
                        zIndex: 1
                      }}
                      className="thead-light"
                    >
                      <tr style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                        {/* Table headers */}
                        <th className="text-center" scope="col">
                          <Tooltip
                            title={
                              alternativeParts.length > 0 &&
                              alternativeParts.some(
                                (el) => el.selectedAlternativePart !== 9999999999999
                              )
                                ? this.translatorService.Tranlate(
                                    'CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_CLEAR_LABEL',
                                    'Goleste'
                                  )
                                : ''
                            }
                          >
                            <div>
                              <Button
                                disabled={
                                  alternativeParts.length > 0 &&
                                  alternativeParts.some(
                                    (el) => el.selectedAlternativePart !== 9999999999999
                                  )
                                    ? false
                                    : true
                                }
                                onClick={(e) =>
                                  this.clearSelectedAlternativeParts(orderPart!.id, index)
                                }
                                className="ml-1 min min-w-auto"
                                size="small"
                                variant="contained"
                                color="primary"
                              >
                                <span className="btn-wrapper--icon">
                                  <FontAwesomeIcon icon={['fas', 'ban']} />
                                </span>
                              </Button>
                            </div>
                          </Tooltip>
                        </th>
                        <th scope="col">
                          {this.translatorService.Tranlate(
                            'CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_CODE_LABEL',
                            'Cod'
                          )}
                        </th>
                        <th scope="col">
                          {this.translatorService.Tranlate(
                            'ORDER_PART_DETAILS_NAME_LABEL',
                            'Denumire'
                          )}
                        </th>
                        <th scope="col">
                          {this.translatorService.Tranlate(
                            'CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_PRICE_LABEL',
                            'Pret'
                          )}
                        </th>
                        <th scope="col">
                          {this.translatorService.Tranlate(
                            'CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_QUALITY_LABEL',
                            'Calitate'
                          )}
                        </th>
                        <th scope="col">
                          {this.translatorService.Tranlate(
                            'CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_DELIVERY_LABEL',
                            'Livrare'
                          )}
                        </th>
                        <th scope="col">
                          {this.translatorService.Tranlate(
                            'CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_OWNER_LABEL_ACRONYM',
                            'Producator'
                          )}
                        </th>
                        <th scope="col">
                          {this.translatorService.Tranlate(
                            'CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_SUPLIER_LABEL',
                            'Furnizor'
                          )}
                        </th>
                        <th scope="col">
                          {this.translatorService.Tranlate(
                            'CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_QUANTITY_INFO_LABEL',
                            'Cant.'
                          )}
                        </th>
                        <th scope="col">
                          {this.translatorService.Tranlate(
                            'CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_STOCK_LOCATION_LABEL',
                            'Locatie'
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      style={{
                        wordBreak: 'break-word',
                        display: 'block',
                        width: '100%',
                        tableLayout: 'fixed'
                      }}
                    >
                      {/* Display data rows */}
                      {alternativeParts.length > 0 ? (
                        alternativeParts.map(
                          (
                            alternativePart: CaseCalculationAlternativePart,
                            alternativePartindex
                          ) => {
                            return (
                              <tr
                                key={alternativePart.id}
                                style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}
                              >
                                <td className="text-center">
                                  <Radio
                                    checked={this.handleAlternativePartChecked(
                                      alternativePart.selectedAlternativePart,
                                      alternativePart.id,
                                      alternativePart.partFromGroup
                                    )}
                                    onChange={(e) =>
                                      this.handleAlternativePartSelectWithStockCheck(
                                        alternativePart.id,
                                        index,
                                        orderPart.id,
                                        alternativePart,
                                        orderPart.pieceNr
                                      )
                                    }
                                    disabled={alternativePart.isChild}
                                    value={alternativePart.id}
                                    id={alternativePart.id.toString()}
                                    name={orderPart.id.toString()}
                                    color="primary"
                                  />
                                </td>
                                <td>{alternativePart.alternativeGuideNumber}</td>
                                <td>
                                  {!R.isNil(alternativePart.remarks) &&
                                  alternativePart.remarks !== '' ? (
                                    <Tooltip
                                      placement="top"
                                      title={
                                        <div>
                                          <div
                                            style={{ fontSize: '16px' }}
                                            className="text-center font-weight-bold mb-2 text-danger"
                                          >
                                            {this.translatorService.Tranlate(
                                              'CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_REMARKS_LABEL',
                                              'Observatii'
                                            )}
                                          </div>
                                          <div>{alternativePart.remarks}</div>
                                        </div>
                                      }
                                    >
                                      <div>{alternativePart.name}</div>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      placement="top"
                                      style={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                      }}
                                      title={
                                        <div>
                                          <div>{alternativePart.name}</div>
                                        </div>
                                      }
                                    >
                                      <div>{alternativePart.name}</div>
                                    </Tooltip>
                                  )}
                                </td>
                                <td>
                                  {R.isNil(alternativePart!.alternativePartDiscount)
                                    ? Utils.countryNumberFormat(
                                        (
                                          Math.round(alternativePart.alternativePrice * 100) / 100
                                        ).toFixed(2),
                                        this.props.appState.appUser?.organization?.country ?? null
                                      )
                                    : Utils.countryNumberFormat(
                                        (
                                          Math.round(
                                            alternativePart.alternativePrice *
                                              (1 - alternativePart!.alternativePartDiscount / 100) *
                                              100
                                          ) / 100
                                        ).toFixed(2),
                                        this.props.appState.appUser?.organization?.country ?? null
                                      )}
                                </td>
                                <td>
                                  {R.isNil(alternativePart.alternativePartQuality)
                                    ? ''
                                    : alternativePart.alternativePartQuality.code}
                                </td>
                                <td>
                                  {alternativePart.deliveryTime ? (
                                    <Tooltip
                                      placement="top"
                                      style={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                      }}
                                      title={
                                        <div>
                                          {alternativePart.deliveryTime
                                            .toString()
                                            .includes(
                                              'in cazul in care piesa se afla in stocul extern'
                                            ) ? (
                                            <>
                                              <span>
                                                {
                                                  alternativePart.deliveryTime
                                                    .toString()
                                                    .split(
                                                      'in cazul in care piesa se afla in stocul extern'
                                                    )[0]
                                                }
                                              </span>
                                              <b style={{ color: 'red' }}>
                                                in cazul in care piesa se afla in stocul extern
                                              </b>
                                            </>
                                          ) : (
                                            alternativePart.deliveryTime
                                          )}
                                        </div>
                                      }
                                    >
                                      <div>
                                        {alternativePart.deliveryTime
                                          .toString()
                                          .includes(
                                            'in cazul in care piesa se afla in stocul extern'
                                          ) ? (
                                          <>
                                            <span>
                                              {
                                                alternativePart.deliveryTime
                                                  .toString()
                                                  .split(
                                                    'in cazul in care piesa se afla in stocul extern'
                                                  )[0]
                                              }
                                            </span>
                                            <b style={{ color: 'red' }}>
                                              in cazul in care piesa se afla in stocul extern
                                            </b>
                                          </>
                                        ) : (
                                          alternativePart.deliveryTime
                                        )}
                                      </div>
                                    </Tooltip>
                                  ) : (
                                    ''
                                  )}
                                </td>
                                <td>{alternativePart.producer}</td>
                                <td>
                                  {!R.isNil(alternativePart.supplier)
                                    ? alternativePart.supplier!.name
                                    : ''}
                                </td>
                                <td>
                                  {alternativePart.quantityAdditionalInfo &&
                                  alternativePart.availableQuantity ? (
                                    <Tooltip
                                      title={<div>{alternativePart.quantityAdditionalInfo}</div>}
                                    >
                                      <div>
                                        <span>{alternativePart.availableQuantity}</span>
                                        <FontAwesomeIcon icon={['fas', 'info-circle']} />
                                      </div>
                                    </Tooltip>
                                  ) : alternativePart.supplierName?.toUpperCase() ===
                                    SupplierCode.LKQ.toString().toUpperCase() ? (
                                    <span>
                                      {isNaN(alternativePart.availableQuantity)
                                        ? null
                                        : alternativePart.availableQuantity > 5
                                        ? '5+'
                                        : alternativePart.availableQuantity}
                                    </span>
                                  ) : (
                                    <span>{alternativePart.availableQuantity}</span>
                                  )}
                                </td>
                                <td>
                                  {alternativePart.stockLocation ? (
                                    <Tooltip
                                      {...rest}
                                      title={
                                        <div>
                                          <div>
                                            {this.translatorService.Tranlate(
                                              'ORDER_PART_DETAILS_LOCATION_LABEL',
                                              'Locatie'
                                            ) +
                                              ': ' +
                                              alternativePart.stockLocation}
                                          </div>
                                        </div>
                                      }
                                    >
                                      <div>
                                        <span>{alternativePart.stockLocation.split('\n')[0]}</span>
                                        <FontAwesomeIcon icon={['fas', 'info-circle']} />
                                      </div>
                                    </Tooltip>
                                  ) : (
                                    alternativePart.stockLocation
                                  )}

                                  {!R.isNil(alternativePart.additionalInfo) &&
                                  alternativePart.additionalInfo !== '' &&
                                  AdditionalInfoCode.PRODUS_NU_POATE_FI_RETURNAT ==
                                    alternativePart.additionalInfo ? (
                                    <p
                                      style={{
                                        color: 'red'
                                      }}
                                    >
                                      {alternativePart.additionalInfo}
                                    </p>
                                  ) : (
                                    ''
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        )
                      ) : (
                        <tr
                          style={{
                            display: 'table',
                            width: '100%',
                            tableLayout: 'fixed'
                          }}
                        >
                          <td className="text-center">
                            <span>
                              {this.translatorService.Tranlate(
                                'NO_RECORDS_TO_DISPLAY',
                                'Nu exista inregistrari de afisat'
                              )}
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </Box>
        </td>
      </tr>
    );
  };

  updateAmount = () => {
    const partList = new OrderParts(
      this.state.orderpartsList.concat(this.getPackageFromOrderParts(this.state.orderpartsList)),
      parseFloat(this.state.TVA)
    );

    const order = { ...this.props.orderDetails };
    order.amountWithoutTVA = partList.totalWithoutVAT();
    order.amountTVA = partList.totalVAT();
    order.amount = partList.total();

    this.props.onOrderChange(order);
  };

  getMuiTheme = () =>
    createMuiTheme(MuiTheme, {
      overrides: {
        MuiTableCell: {
          paddingCheckbox: {
            padding: '0px'
          }
        },
        MUIDataTableSelectCell: {
          expandDisabled: {
            visibility: 'hidden'
          }
        }
      } as any
    });

  interogateAll = async () => {
    this.getInactiveWorkflowSuppliers();
    try {
      const parts = [...this.state.orderpartsList];
      for (const cp of parts) {
        const index = parts.indexOf(cp);
        if (cp.hasBeenVerifiedBySupplier) {
          await this.interogate(cp, index);
        }
      }
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  renderInterogateAllSection = () => {
    return this.state.rowsExpanded.length > 0 ? (
      <Card className="mt-2">
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoadingOrderDetails} />
        </div>
        {!this.state.isLoadingOrderDetails ? (
          <CardContent className="p-3">
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <div className="d-flex align-items-center">
                  <Button
                    className="mr-2"
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      this.interogateAll();
                    }}
                  >
                    {this.translatorService.Tranlate('INTEROGATE', 'Interogheaza')}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        ) : null}
      </Card>
    ) : null;
  };

  renderOrderPartsSection = () => {
    const options = {
      filter: false,
      sort: false,
      search: false,
      pagination: false,
      viewColumns: false,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      elevation: 0,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      // Folosește rowClassName pentru a aplica o clasă pe rânduri
      rowClassName: (rowData: any, rowIndex: number) => {
        const row = this.state.orderpartsList[rowIndex];
        // Aplică o clasă diferită pentru fiecare rând, în funcție de `hasBeenVerifiedBySupplier`
        return row && row.hasBeenVerifiedBySupplier ? 'verified-row' : 'unverified-row';
      },
      expandableRowsHeader: false,
      expandableRows: this.state.rowsExpanded.length > 0 ? true : false,
      // Prevent expand icon from rendering for rows that are not verified
      isRowExpandable: (dataIndex: number, expandedRow: any) => {
        const row = this.state.orderpartsList[dataIndex];
        return row && row.hasBeenVerifiedBySupplier; // Only allow expansion if verified
      },
      renderExpandableRow: (rowData: any, rowMeta: any) => {
        const row = this.state.orderpartsList[rowMeta.dataIndex];
        // Only render expandable content if the row is verified by the supplier
        if (row && row.hasBeenVerifiedBySupplier) {
          return this.renderExpandedRow(rowData, rowMeta);
        }
        return null; // No expandable content for unverified rows
      },
      rowsExpanded: this.state.rowsExpanded
    };
    return (
      <Card className="mt-2">
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoadingOrderDetails} />
        </div>
        {!this.state.isLoadingOrderDetails ? (
          <Box m={1} p={1}>
            <MuiThemeProvider theme={this.getMuiTheme()}>
              <MUIDataTable
                title={''}
                data={this.state.orderpartsList}
                columns={this.getPartsByColumns()}
                options={options}
              />
            </MuiThemeProvider>
          </Box>
        ) : null}
      </Card>
    );
  };

  checkIfOrderPartsChangedDuringOrderPlacement = async () => {
    const orderDatePlacement = new Date();
    let validityTimeOkay = true;
    const caseCalculationPartsThatChangedDuringPlacingOrder: CaseCalculationSupplierAlternativePart[] =
      [];

    this.state.orderpartsList.forEach((orderPart) => {
      orderPart.prevVal = null;
    });
    this.setState({
      caseCalculationPartsThatChangedDuringPlacingOrder: []
    });

    this.getInactiveWorkflowSuppliers();
    //Detect if the order part list was changed during the order placemenent
    (await Promise.all(
      this.state.orderpartsList.map(async (product) => {
        if (!product.isDeleted) {
          const freshOrderedParts =
            await this.caseService.InterogateCaseCalculationsAlternativePartsBySupplier({
              partId: product.id,
              partNumber: product.guideNumber,
              addition: this.props.additionTariff.value,
              discount: this.props.discountTariff.value,
              workflowId:
                this.props.caseSettingsState?.caseSettings?.workflow.id ??
                this.props.orderDetails.case?.caseWorkflow?.workflowId,
              supplierId: this.props.orderDetails.supplierId ?? 0,
              organizationId: this.props.orderDetails.partsLocationOrganizationId,
              qty: product.pieceNr
            } as GetSuppliersAlternativePartsRequestDto);
          const changedOrderedProducts = freshOrderedParts.filter(
            (part) =>
              part.supplierId == product.supplierId &&
              part.producer == product.producer &&
              part.alternativeGuideNumber == product.alternativeGuideNumber &&
              part.name == product.alternativePartName &&
              part.alternativePartCode == product.alternativePartCode &&
              part.orderCode == product.orderCode
          );
          console.log('changedOrderedProducts', changedOrderedProducts);
          if (changedOrderedProducts.length == 1) {
            const changedOrderedProduct = changedOrderedProducts[0];
            if (
              changedOrderedProduct.alternativePriceWithoutDiscount !== product.alternativePrice ||
              changedOrderedProduct.deliveryTime !== product.deliveryTime ||
              changedOrderedProduct.validityTime !== product.validityTime ||
              changedOrderedProduct.type != product.type ||
              changedOrderedProduct.orderCode != product.orderCode
            ) {
              caseCalculationPartsThatChangedDuringPlacingOrder.push({
                prevVal: _.cloneDeep(product),
                newVal: _.cloneDeep(changedOrderedProduct)
              });
              product.prevVal = {
                ...product
              };
              if (
                product.alternativePrice != changedOrderedProduct.alternativePriceWithoutDiscount
              ) {
                product.alternativePrice = changedOrderedProduct.alternativePriceWithoutDiscount;
              }
              if (product.deliveryTime != changedOrderedProduct.deliveryTime) {
                product.deliveryTime = changedOrderedProduct.deliveryTime;
                product.expectedDeliveryDate = changedOrderedProduct.expectedDeliveryDate || null;
              }
              if (product.type != changedOrderedProduct.type) {
                product.type = changedOrderedProduct.type;
              }
              if (product.orderCode != changedOrderedProduct.orderCode) {
                product.orderCode = changedOrderedProduct.orderCode;
              }
              if (product.validityTime != changedOrderedProduct.validityTime) {
                product.validityTime = changedOrderedProduct.validityTime;
              }
            }
            if (product.validityTime) {
              if (new Date(orderDatePlacement) > new Date(product.validityTime)) {
                validityTimeOkay = false;
                this.props.enqueueSnackbar(
                  'Codul: ' +
                    changedOrderedProduct.alternativeGuideNumber +
                    ' producator: ' +
                    changedOrderedProduct.producer +
                    ' furnizor: ' +
                    this.props.orderDetails.supplier?.name +
                    ' nu mai este valid. \n' +
                    'A fost valid pana la : ' +
                    moment
                      .utc(changedOrderedProduct.validityTime)
                      .local()
                      .format(this.props.appState.longDateFormat),
                  {
                    variant: 'warning'
                  }
                );
              }
            }
          }
        }
      })
    )) || [];

    console.log(
      'caseCalculationPartsThatChangedDuringPlacingOrder',
      caseCalculationPartsThatChangedDuringPlacingOrder
    );

    if (!validityTimeOkay) {
      return true;
    }

    if (caseCalculationPartsThatChangedDuringPlacingOrder.length > 0) {
      this.setState({
        caseCalculationPartsThatChangedDuringPlacingOrder:
          caseCalculationPartsThatChangedDuringPlacingOrder,
        isChangeOrderStatusDialogOpen: false,
        isLoadingOrderDetails: false
      });

      this.props.enqueueSnackbar(
        this.translatorService.Tranlate('ERROR_MSG_SMTH', 'Produsele comandate au fost modificate'),
        {
          variant: 'warning'
        }
      );

      //Update the order parts
      await Promise.all(
        caseCalculationPartsThatChangedDuringPlacingOrder.map(async (row) => {
          const part = row.newVal;
          const orderedPart = this.state.orderpartsList.filter(
            (product) =>
              part!.supplierId == product.supplierId &&
              part!.producer == product.producer &&
              part!.alternativeGuideNumber == product.alternativeGuideNumber &&
              part!.name == product.alternativePartName &&
              part.alternativePartCode == product.alternativePartCode
          )[0];
          await this.orderService.UpdateOrderPart(orderedPart!);
        })
      );

      const order = { ...this.props.orderDetails };
      const newOrder = await this.orderService.UpdateOrderAmounts({
        orderId: this.props.orderDetails.id
      } as UpdateOrderAmountsRequestDto);

      order.amountWithoutTVA = newOrder!.amountWithoutTVA;
      order.amountTVA = newOrder!.amountTVA;
      order.amount = newOrder!.amount;

      this.props.onOrderChange(order);

      return true;
    }

    return false;
  };

  checkIfOrderPartsVerifiedBySupplier = () => {
    return this.state.orderpartsList.some((orderPart) => orderPart.hasBeenVerifiedBySupplier);
  };

  updateSupplierOrder = async () => {
    try {
      const orderStatusHistory = [...this.state.orderStatusHistory];

      this.setState({ isLoadingOrderDetails: true, executing: true });

      const orderedPartsChanged = [...this.state.orderpartsList]
        .filter((orderPart) => orderPart.hasBeenVerifiedBySupplier)
        .map((orderPart) => ({
          ...orderPart,
          alternativePartQuality: null,
          carPartCategory: null,
          supplier: null,
          status: null
        }));

      //Daca piesele sunt modificate de catre furnizor
      if (orderedPartsChanged.length > 0) {
        const updateOrderInfoRequest = {
          orderId: this.props.orderDetails.id,
          calculationId: this.state.firstCasePartToBeOrdered?.caseCalculationHistoryId ?? 0,
          parts: orderedPartsChanged
        } as UpdateOrderInfoRequest;

        await this.caseService.UpdateOrderInfo(updateOrderInfoRequest);

        const vin = !R.isNil(this.props.caseSettingsState.case)
          ? this.props.caseSettingsState.case.caseVehicle.vin
          : this.props.orderDetails.caseVehicle.vin;
        const make = this.state.model ? this.state.model.brand : '';
        const model = this.state.model ? this.state.model.description : '';
        await Promise.all([
          orderedPartsChanged.map(async (orderPart) => {
            await this.caseService.AddNonStockPart({
              vin: vin,
              make: make,
              model: model,
              oeCode: orderPart.guideNumberBackup,
              oeSupplierCode:
                !R.isNil(this.state.quality) &&
                this.state.quality.code === CarPartQualityTypeCode.OE
                  ? orderPart.guideNumber
                  : orderPart.alternativeGuideNumber ?? '',
              supplierId: this.props.orderDetails.supplierId
            } as NonStockPart);
          })
        ]);
      }

      const nextOrderStatus = this.getNextOrderStatus();
      const request = {
        statusId: nextOrderStatus?.id,
        comment: this.state.changeOrderStatusComment,
        orderId: this.props.orderDetails.id,
        attachments: this.state.attachments,
        partsLocationOrganizationId: this.props.orderDetails.partsLocationOrganizationId,
        workflowId:
          this.props.caseSettingsState?.caseSettings?.workflow.id ??
          this.props.orderDetails.case?.caseWorkflow?.workflowId,
        partsOrganizationId: this.props.orderDetails.partsOrganizationId
      } as OrderStatusChangeRequestDto;
      await this.orderService.ChangeOrderStatus(request);

      if (orderedPartsChanged.length > 0) {
        const statusHistory = this.state.orderStatusHistory.find(
          (x) => x.orderStatus?.code == OrderStatusCode.FZR_VERIFICARE_LA_FURNIZOR
        );
        const notificationRequest = {
          orderId: this.props.orderDetails.id,
          orderComment: this.state.changeOrderStatusComment,
          caseId: this.props.orderDetails.caseId,
          template: OrderNotificationTemplateEnum.VERIFIED_BY_SUPPLIER,
          email: statusHistory ? statusHistory.createdByUser?.email ?? '' : ''
        };
        await this.caseService.SendVerifiedBySupplierOrderNotification(notificationRequest);
      }

      const order = { ...this.props.orderDetails };
      order.orderStatus = nextOrderStatus!;
      order.orderStatusId = nextOrderStatus!.id;

      this.props.onOrderChange(order);

      orderStatusHistory.unshift({
        id: 1,
        orderId: this.props.orderDetails.id,
        orderStatusId: this.props.orderDetails.orderStatusId,
        orderStatus: nextOrderStatus!,
        date: new Date(),
        createdBy: this.props.appState.appUser!.id!,
        createdByUser: this.props.appState.appUser,
        comment: this.state.changeOrderStatusComment,
        attachments: this.state.attachments.length > 0 ? this.state.attachments : null
      });

      if (orderedPartsChanged.length > 0) {
        this.setState({
          orderStatusHistory: orderStatusHistory,
          isLoadingOrderDetails: false,
          isChangeOrderStatusDialogOpen: false,
          executing: false
        });

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
        return;
      }

      this.setState({
        orderStatusHistory: orderStatusHistory
      });
      await this.placeSupplierOrder();
    } catch (ex) {
      this.setState({
        isLoadingOrderDetails: false,
        executing: false
      });
      console.log('Exception:' + ex);
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  placeSupplierOrder = async () => {
    const orderedPartsChanged = await this.checkIfOrderPartsChangedDuringOrderPlacement();
    console.log(
      'Changed Order Part List ',
      this.state.caseCalculationPartsThatChangedDuringPlacingOrder
    );
    if (orderedPartsChanged) {
      this.setState({ executing: false });
      return;
    }
    const orderedPartStatus = this.state.orderPartStatus.find(
      (item) => item.code === OrderPartStatus.PROCESSING
    )!;
    const nextOrderStatus = this.state.statuses.find(
      (item) => item.code === OrderStatusCode.REP_PLASATA
    );

    const request = {
      statusId: nextOrderStatus?.id,
      orderPartStatusId: orderedPartStatus.id,
      comment: this.state.changeOrderStatusComment,
      orderId: this.props.orderDetails.id,
      attachments: this.state.attachments,
      partsLocationOrganizationId: this.props.orderDetails.partsLocationOrganizationId,
      workflowId:
        this.props.caseSettingsState?.caseSettings?.workflow.id ??
        this.props.orderDetails.case?.caseWorkflow?.workflowId,
      partsOrganizationId: this.props.appState.appUser?.organizationId
    } as OrderStatusChangeRequestDto;

    await this.orderService.ChangeOrderStatus(request);

    this.state.orderpartsList.map((product) => {
      if (!product.isDeleted) {
        product.status = orderedPartStatus;
        product.statusId = orderedPartStatus.id;
      }
    });

    const orderStatusHistory = [...this.state.orderStatusHistory];

    const order = { ...this.props.orderDetails };
    order.orderStatus = nextOrderStatus!;
    order.orderStatusId = nextOrderStatus!.id;

    this.props.onOrderChange(order);

    orderStatusHistory.unshift({
      id: 1,
      orderId: this.props.orderDetails.id,
      orderStatusId: this.props.orderDetails.orderStatusId,
      orderStatus: nextOrderStatus!,
      date: new Date(),
      createdBy: this.props.appState.appUser!.id!,
      createdByUser: this.props.appState.appUser,
      comment: this.state.changeOrderStatusComment,
      attachments: this.state.attachments.length > 0 ? this.state.attachments : null
    });

    if (
      this.props.orderDetails.supplier?.name == SupplierCode.MATEROM ||
      this.props.orderDetails.supplier?.name == SupplierCode.ADTOTAL ||
      this.props.orderDetails.supplier?.name == SupplierCode.CONEX ||
      this.props.orderDetails.supplier?.name == SupplierCode.EUROEST ||
      this.props.orderDetails.supplier?.name == SupplierCode.LKQ ||
      this.props.orderDetails.supplier?.name == SupplierCode.NESTE
    ) {
      const order = await this.orderService.GetOrder(this.props.orderDetails.id, false);
      if (order.supplierOrderNumber) {
        const proceedOrderStatus = this.state.orderStatuses.find(
          (item) => item.code === OrderStatusCode.FZR_COMANDA_CONFIRMATA
        );
        const proceedPartStatus = this.state.orderPartStatus.find(
          (item) => item.code === OrderPartStatus.PROCESSED
        )!;
        const request = {
          statusId: proceedOrderStatus?.id,
          orderPartStatusId: proceedPartStatus.id,
          comment: '',
          orderId: this.props.orderDetails.id,
          attachments: [],
          partsLocationOrganizationId: this.props.orderDetails.partsLocationOrganizationId,
          workflowId:
            this.props.caseSettingsState?.caseSettings?.workflow.id ??
            this.props.orderDetails.case?.caseWorkflow?.workflowId,
          partsOrganizationId: this.props.appState.appUser?.organizationId
        } as OrderStatusChangeRequestDto;

        await this.orderService.ChangeOrderStatus(request);

        this.state.orderpartsList.map((product) => {
          if (!product.isDeleted) {
            product.status = proceedPartStatus;
            product.statusId = proceedPartStatus.id;
          }
        });

        await this.caseService.SendConfirmedOrderNotification(
          this.props.orderDetails.caseId,
          this.props.orderDetails.id
        );

        const order = { ...this.props.orderDetails };
        order.orderStatus = proceedOrderStatus!;
        order.orderStatusId = proceedOrderStatus!.id;

        this.props.onOrderChange(order);

        orderStatusHistory.unshift({
          id: 0,
          orderId: this.props.orderDetails.id,
          orderStatusId: this.props.orderDetails.orderStatusId,
          orderStatus: proceedOrderStatus!,
          date: new Date(),
          createdBy: this.props.appState.appUser!.id!,
          createdByUser: this.props.appState.appUser,
          comment: '',
          attachments: []
        });
      }
    }

    this.setState({
      orderStatusHistory: orderStatusHistory,
      isChangeOrderStatusDialogOpen: false,
      selectedDisplayedStatus: this.state.selectedStatus.displayName,
      changeOrderStatusComment: '',
      attachments: [],
      isLoadingOrderDetails: false,
      executing: false
    });

    this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
      variant: 'success'
    });
    this.props.onOrderPlacedSuccessfully();
  };

  validateOrder = (): boolean => {
    const nonInterogatedParts = [...this.state.orderpartsList].filter(
      (orderPart) => orderPart.hasBeenVerifiedBySupplier && !orderPart.supplierId
    );
    if (nonInterogatedParts.length > 0) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          'ORDER_PLEASE_SELECT_PART',
          'Selectati piese pentru urmatoarele id-uri: '
        ) + nonInterogatedParts.map((x) => x.id).join(', '),
        {
          variant: 'warning'
        }
      );
      return true;
    }

    const orderParts = [...this.state.orderpartsList.filter((x) => x.hasBeenVerifiedBySupplier)];
    let errorString = '';
    let decimalError = false;
    orderParts.map((orderPart) => {
      [...orderPart.alternativeParts].map((item) => {
        if (item.originalPartId === orderPart.id) {
          if (item.selectedAlternativePart !== 9999999999999) {
            const filtercalculationParts = _.filter([...orderParts], function (orderPartObject) {
              return (
                orderPartObject.alternativeGuideNumber == orderPart.alternativeGuideNumber &&
                orderPartObject.alternativePartCode == orderPart.alternativePartCode &&
                orderPartObject.supplierId == orderPart.supplierId
              );
            });

            const currentPacking = item.packing?.split('|')[0];
            const secondItemOfPacking = item.packing?.split('|')[1];
            if (currentPacking && secondItemOfPacking) {
              const currentPackingNumber = parseFloat(currentPacking);
              if (filtercalculationParts && filtercalculationParts.length) {
                const pieceNr = _.sumBy(filtercalculationParts, 'pieceNr');
                console.log('filtercalculationParts');
                console.log(filtercalculationParts);
                console.log(pieceNr);
                if (pieceNr % currentPackingNumber == 0) {
                  return;
                }
              }
              if (
                orderPart.pieceNr % currentPackingNumber != 0 ||
                orderPart.pieceNr < orderPart.minQty
              ) {
                errorString +=
                  this.translatorService.Tranlate(
                    'MIN_PACKING_ERROR_MSG',
                    'Cantitatea comandata trebuie sa fie '
                  ) +
                  currentPackingNumber +
                  this.translatorService.Tranlate(
                    'MIN_PACKING_MULTIPLE_ERROR_MSG',
                    ' sau multiplul acesteia!'
                  ) +
                  ' \n';
                this.validateOrigPartUnitsAdd(orderPart.id);
                return;
              }
            } else {
              if (orderPart.pieceNr < orderPart.minQty) {
                errorString +=
                  this.translatorService.Tranlate(
                    'MIN_PACKING_ERROR_MSG',
                    'Cantitatea comandata trebuie sa fie '
                  ) +
                  orderPart.minQty +
                  this.translatorService.Tranlate(
                    'MIN_PACKING_MULTIPLE_ERROR_MSG',
                    ' sau multiplul acesteia!'
                  ) +
                  ' \n';
                this.validateOrigPartUnitsAdd(orderPart.id);
                return;
              }
            }
            if (!Number.isInteger(orderPart.pieceNr)) {
              decimalError = true;
              this.validateOrigPartUnitsAdd(orderPart.id);
              return;
            }
            if (!R.isNil(item.availableQuantity) && item.availableQuantity < orderPart.pieceNr) {
              this.validateOrigPartUnitsAdd(orderPart.id);
            } else {
              this.validateOrigPartUnitsRemove(orderPart.id);
            }
          }
        }
      });
    });

    if (errorString) {
      this.props.enqueueSnackbar(errorString, {
        variant: 'warning',
        style: { whiteSpace: 'pre-line' }
      });
      return true;
    }

    if (decimalError) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          'DECIMAL_ERROR_MSG',
          'Cantitatea comandata trebuie sa fie un numar intreg fara zecimale'
        ),
        {
          variant: 'warning'
        }
      );
      return true;
    }

    return false;
  };

  updateOrderAfterInterogation = async () => {
    try {
      console.log('updateOrderAfterInterogation');
      const orderStatusHistory = [...this.state.orderStatusHistory];

      this.setState({ isLoadingOrderDetails: true, executing: true });

      const orderParts = this.state.orderpartsList.concat(
        this.getPackageFromOrderParts(this.state.orderpartsList)
      );
      const orderedPartsChanged = [...orderParts]
        .filter((orderPart) => orderPart.hasBeenVerifiedBySupplier)
        .map((orderPart) => ({
          ...orderPart,
          alternativePartQuality: null,
          carPartCategory: null,
          supplier: null,
          status: null
        }));

      if (orderedPartsChanged.length > 0) {
        const updateOrderInfoRequest = {
          orderId: this.props.orderDetails.id,
          calculationId: this.state.firstCasePartToBeOrdered?.caseCalculationHistoryId ?? 0,
          parts: orderedPartsChanged
        } as UpdateOrderInfoRequest;
        await this.caseService.UpdateOrderInfo(updateOrderInfoRequest);
      }

      const nextOrderStatus = this.getNextOrderStatus();
      const request = {
        statusId: nextOrderStatus?.id,
        comment: this.state.changeOrderStatusComment,
        orderId: this.props.orderDetails.id,
        attachments: this.state.attachments,
        partsLocationOrganizationId: this.props.orderDetails.partsLocationOrganizationId,
        workflowId:
          this.props.caseSettingsState?.caseSettings?.workflow.id ??
          this.props.orderDetails.case?.caseWorkflow?.workflowId,
        partsOrganizationId: this.props.orderDetails.partsOrganizationId
      } as OrderStatusChangeRequestDto;
      await this.orderService.ChangeOrderStatus(request);

      const order = await this.orderService.GetOrder(this.props.orderDetails.id, true);
      this.props.onOrderChange(order);

      orderStatusHistory.unshift({
        id: 1,
        orderId: this.props.orderDetails.id,
        orderStatusId: this.props.orderDetails.orderStatusId,
        orderStatus: nextOrderStatus!,
        date: new Date(),
        createdBy: this.props.appState.appUser!.id!,
        createdByUser: this.props.appState.appUser,
        comment: this.state.changeOrderStatusComment,
        attachments: this.state.attachments.length > 0 ? this.state.attachments : null
      });

      this.setState({
        orderStatusHistory: orderStatusHistory,
        isLoadingOrderDetails: false,
        isChangeOrderStatusDialogOpen: false,
        executing: false,
        rowsExpanded: [],
        orderpartsList: order.orderParts!.map((item) => {
          return { ...item } as OrderPartDTO;
        })
      });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (ex) {
      this.setState({
        isLoadingOrderDetails: false,
        executing: false
      });
      console.log('Exception:' + ex);
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  changeOrderStatusSubmit = async () => {
    const currentStatus = this.getStatusValue();
    if (currentStatus?.code === OrderStatusCode.FZR_VERIFICARE_LA_FURNIZOR) {
      await this.updateSupplierOrder();
      return;
    }
    if (
      currentStatus?.code === OrderStatusCode.REP_VERIFICATA_DE_FURNIZOR &&
      this.state.rowsExpanded.length > 0
    ) {
      const hasError = this.validateOrder();
      if (hasError) {
        return;
      }
      await this.updateOrderAfterInterogation();
      return;
    }

    if (
      this.props.orderDetails.interogatePartner &&
      !this.props.orderDetails.partsLocationOrganizationId
    ) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          'ORDER_WITHOUT_DELIVERY_ADRESS_MSG',
          'Comanda nu poata fi lansata pentru ca nu are adresa de livrare!'
        ),
        {
          variant: 'warning'
        }
      );
      return;
    }

    try {
      this.setState({ isLoadingOrderDetails: true, executing: true });
      const orderedPartsChanged = await this.checkIfOrderPartsChangedDuringOrderPlacement();
      console.log(
        'Changed Order Part List ',
        this.state.caseCalculationPartsThatChangedDuringPlacingOrder
      );
      if (orderedPartsChanged) {
        this.setState({ executing: false });
        return;
      }
      const orderedPartStatus = this.state.orderPartStatus.find(
        (item) => item.code === OrderPartStatus.PROCESSING
      )!;
      const nextOrderStatus = this.getNextOrderStatus();

      const request = {
        statusId: nextOrderStatus?.id,
        orderPartStatusId: orderedPartStatus.id,
        comment: this.state.changeOrderStatusComment,
        orderId: this.props.orderDetails.id,
        attachments: this.state.attachments,
        partsLocationOrganizationId: this.props.orderDetails.partsLocationOrganizationId,
        workflowId:
          this.props.caseSettingsState?.caseSettings?.workflow.id ??
          this.props.orderDetails.case?.caseWorkflow?.workflowId,
        partsOrganizationId: this.props.appState.appUser?.organizationId
      } as OrderStatusChangeRequestDto;

      await this.orderService.ChangeOrderStatus(request);

      this.state.orderpartsList.map((product) => {
        if (!product.isDeleted) {
          product.status = orderedPartStatus;
          product.statusId = orderedPartStatus.id;
        }
      });

      const orderStatusHistory = [...this.state.orderStatusHistory];

      const order = { ...this.props.orderDetails };
      order.orderStatus = nextOrderStatus!;
      order.orderStatusId = nextOrderStatus!.id;

      this.props.onOrderChange(order);

      orderStatusHistory.unshift({
        id: 1,
        orderId: this.props.orderDetails.id,
        orderStatusId: this.props.orderDetails.orderStatusId,
        orderStatus: nextOrderStatus!,
        date: new Date(),
        createdBy: this.props.appState.appUser!.id!,
        createdByUser: this.props.appState.appUser,
        comment: this.state.changeOrderStatusComment,
        attachments: this.state.attachments.length > 0 ? this.state.attachments : null
      });

      if (
        this.props.orderDetails.supplier?.name == SupplierCode.MATEROM ||
        this.props.orderDetails.supplier?.name == SupplierCode.ADTOTAL ||
        this.props.orderDetails.supplier?.name == SupplierCode.CONEX ||
        this.props.orderDetails.supplier?.name == SupplierCode.EUROEST ||
        this.props.orderDetails.supplier?.name == SupplierCode.LKQ ||
        this.props.orderDetails.supplier?.name == SupplierCode.NESTE
      ) {
        const order = await this.orderService.GetOrder(this.props.orderDetails.id, false);
        if (order.supplierOrderNumber) {
          const proceedOrderStatus = this.state.orderStatuses.find(
            (item) => item.code === OrderStatusCode.FZR_COMANDA_CONFIRMATA
          );
          const proceedPartStatus = this.state.orderPartStatus.find(
            (item) => item.code === OrderPartStatus.PROCESSED
          )!;
          const request = {
            statusId: proceedOrderStatus?.id,
            orderPartStatusId: proceedPartStatus.id,
            comment: '',
            orderId: this.props.orderDetails.id,
            attachments: [],
            partsLocationOrganizationId: this.props.orderDetails.partsLocationOrganizationId,
            workflowId:
              this.props.caseSettingsState?.caseSettings?.workflow.id ??
              this.props.orderDetails.case?.caseWorkflow?.workflowId,
            partsOrganizationId: this.props.appState.appUser?.organizationId
          } as OrderStatusChangeRequestDto;

          await this.orderService.ChangeOrderStatus(request);

          this.state.orderpartsList.map((product) => {
            if (!product.isDeleted) {
              product.status = proceedPartStatus;
              product.statusId = proceedPartStatus.id;
            }
          });

          await this.caseService.SendConfirmedOrderNotification(
            this.props.orderDetails.caseId,
            this.props.orderDetails.id
          );

          const order = { ...this.props.orderDetails };
          order.orderStatus = proceedOrderStatus!;
          order.orderStatusId = proceedOrderStatus!.id;

          this.props.onOrderChange(order);

          orderStatusHistory.unshift({
            id: 0,
            orderId: this.props.orderDetails.id,
            orderStatusId: this.props.orderDetails.orderStatusId,
            orderStatus: proceedOrderStatus!,
            date: new Date(),
            createdBy: this.props.appState.appUser!.id!,
            createdByUser: this.props.appState.appUser,
            comment: '',
            attachments: []
          });
        }
      }

      console.log(orderStatusHistory);

      await this.props.automatePlaceOrderChange();
      this.setState({
        orderStatusHistory: orderStatusHistory,
        isChangeOrderStatusDialogOpen: false,
        selectedDisplayedStatus: this.state.selectedStatus.displayName,
        changeOrderStatusComment: '',
        attachments: [],
        isLoadingOrderDetails: false,
        executing: false
      });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
      this.props.onOrderPlacedSuccessfully();
    } catch (ex) {
      this.setState({
        isLoadingOrderDetails: false,
        executing: false
      });
      console.log('Exception:' + ex);
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleAutocompleteOrderStatusChange = async (newValue: any | null) => {
    this.setState({
      selectedStatus: newValue
    });
  };

  handleOrderPartsStatusChange = async (part: OrderPart, newVal: IReferential | null) => {
    try {
      await this.orderService.ChangeOrderPartStatus(part.id, newVal!.id);
      const order = await this.orderService.GetOrder(this.props.orderDetails.id, false);

      const newArray = [...this.state.orderpartsList];
      const index = newArray.findIndex((item) => item.id === part.id);
      newArray[index] = {
        ...newArray[index],
        status: newVal,
        statusId: newVal !== null ? newVal.id : null
      };

      order.orderParts = newArray;

      this.props.onOrderChange(order);
      this.setState({
        orderpartsList: newArray
      });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleExtendDelivery = async (partId: number) => {
    const part = this.state.selectedOrderPart;
    const days = this.state.extensionDays;
    if (!part || days === null || days <= 0) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate('EXTEND_DELIVERY_INVALID_DAYS', 'Numar de zile invalid'),
        { variant: 'warning' }
      );
      return;
    }
    if (isNullOrUndefined(part.expectedDeliveryDate)) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          'EXTEND_DELIVERY_NO_EXPECTED_DATE',
          'Piesa nu are data de livrare setata'
        ),
        { variant: 'warning' }
      );
      return;
    }

    try {
      const result: ExtendDeliveryResponseDto = await this.orderService.ExtendDelivery({
        orderPartId: part.id,
        currentExpectedDeliveryDate: part.expectedDeliveryDate,
        extensionDaysAdded: days
      } as ExtendDeliveryRequestDto);

      if (!result || !result.success) {
        const messageKey = result?.message || 'EXTEND_DELIVERY_ERROR';
        this.props.enqueueSnackbar(this.translatorService.Tranlate(messageKey, messageKey), {
          variant: 'warning'
        });
        return;
      }

      const newList = [...this.state.orderpartsList];
      const idx = newList.findIndex((item) => item.id === part.id);
      newList[idx] = {
        ...newList[idx],
        deliveryExtensionDays: (newList[idx].deliveryExtensionDays ?? 0) + days,
        expectedDeliveryDate: result.data?.deliveryDate ?? null
      };

      this.setState({ orderpartsList: newList });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  canUpdateOrderPartStatus = (part: OrderPartDTO): boolean => {
    if (this.props.orderDetails.clientId !== this.props.appState.appUser!.organizationId) {
      return false;
    }

    if (this.isAwaitingSupplierConfirmation()) {
      return false;
    }

    return (
      part.status?.code === OrderPartStatus.PROCESSED ||
      part.status?.code === OrderPartStatus.PROCESSING
    );
  };

  isAwaitingSupplierConfirmation = (): boolean => {
    if (this.getStatusValue()?.code !== OrderStatusCode.REP_PLASATA) {
      return false;
    }

    return (
      this.props.orderDetails.supplier?.name == SupplierCode.AUGSBURG ||
      this.props.orderDetails.supplier?.name == SupplierCode.AUTONET
    );
  };

  handleMarkAsDelivered = async (partId: number) => {
    try {
      const newArray = [...this.state.orderpartsList];
      const selectedPart = newArray.find((item) => item.id === partId);
      const groupedPartIds = newArray
        .filter((item) => item.groupedUniqueId === selectedPart?.groupedUniqueId)
        .map((item) => item.id);
      const idsToUpdate = groupedPartIds.length > 0 ? groupedPartIds : [partId];

      const updatedParts = await this.orderService.UpdateOrderPartStatus({
        orderPartIds: idsToUpdate,
        statusCode: OrderPartStatus.LIVRATA,
        shouldRequery: false
      });

      const order = await this.orderService.GetOrder(this.props.orderDetails.id, false);
      const orderStatusHistory = await this.orderService.GetOrderStatusHistories(
        this.props.orderDetails.id
      );

      updatedParts.forEach((updatedPart) => {
        const idx = newArray.findIndex((item) => item.id === updatedPart.id);
        if (idx !== -1) newArray[idx] = { ...newArray[idx], ...updatedPart };
      });

      order.orderParts = newArray;
      this.props.onOrderChange(order);
      this.setState({ orderpartsList: newArray, orderStatusHistory });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleCancelPartRequeryConfirm = async (shouldRequery: boolean) => {
    const { pendingUpdateStatusPartId } = this.state;
    if (pendingUpdateStatusPartId == null) return;

    try {
      const newArray = [...this.state.orderpartsList];
      const selectedPart = newArray.find((item) => item.id === pendingUpdateStatusPartId);
      const groupedPartIds = newArray
        .filter((item) => item.groupedUniqueId === selectedPart?.groupedUniqueId)
        .map((item) => item.id);
      const idsToUpdate = groupedPartIds.length > 0 ? groupedPartIds : [pendingUpdateStatusPartId];

      const updatedParts = await this.orderService.UpdateOrderPartStatus({
        orderPartIds: idsToUpdate,
        statusCode: OrderPartStatus.ANULATA,
        shouldRequery
      });

      const order = await this.orderService.GetOrder(this.props.orderDetails.id, false);
      const orderStatusHistory = await this.orderService.GetOrderStatusHistories(
        this.props.orderDetails.id
      );

      updatedParts.forEach((updatedPart) => {
        const idx = newArray.findIndex((item) => item.id === updatedPart.id);
        if (idx !== -1) newArray[idx] = { ...newArray[idx], ...updatedPart };
      });

      order.orderParts = newArray;
      this.props.onOrderChange(order);
      this.setState({
        orderpartsList: newArray,
        orderStatusHistory,
        isCancelPartRequeryDialogOpen: false,
        pendingUpdateStatusPartId: null
      });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  renderExtendDeliveryForm = () => {
    return (
      <ValidatorForm
        onSubmit={async () => {
          if (this.state.selectedOrderPart != null) {
            await this.handleExtendDelivery(this.state.selectedOrderPart.id);
            this.closeExtendDialog();
          }
        }}
      >
        <DialogContent className="p-3" dividers>
          <TextValidator
            fullWidth
            id="extensionDays"
            name="extensionDays"
            type="number"
            label={this.translatorService.Tranlate(
              'ORDER_PART_EXTENSION_DAYS_LABEL',
              'Zile prelungire'
            )}
            value={this.state.extensionDays}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              this.setState({
                extensionDays: e.target.value === '' ? null : parseInt(e.target.value)
              })
            }
            inputProps={{ min: 1, max: MAX_EXTENSION_DAYS }}
            validators={['required', 'minNumber:1', `maxNumber:${MAX_EXTENSION_DAYS}`]}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
              this.translatorService.Tranlate('VALIDATORS_MIN_1', 'Valoarea minima este 1'),
              this.translatorService.Tranlate(
                'VALIDATORS_MAX_EXTENSION_DAYS',
                'Numarul maxim de zile de prelungire este 30'
              )
            ]}
            variant="outlined"
          />
        </DialogContent>
        <div className="p-3 d-flex justify-content-end">
          <Button variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('SAVE', 'Salveaza')}
          </Button>
        </div>
      </ValidatorForm>
    );
  };

  formatDeliveryDate = (date: string | null): string => {
    if (!date) return '';
    return moment(date)
      .format(this.props.appState.longDateFormat)
      .replace(/ 00:00(:00)?$/, '');
  };

  renderDeliveryDateHistory = () => {
    return (
      <DialogContent className="p-3" dividers>
        {this.state.historyDialogData.length === 0 ? (
          <b>
            {this.translatorService.Tranlate(
              'ORDER_DETAILS_HISTORY_NO_DATA',
              'Nu exista date de afisat!'
            )}
          </b>
        ) : (
          <div className="timeline-list timeline-list--primary">
            {this.state.historyDialogData.map((row, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-item--content">
                  <div className="timeline-item--icon" />
                  <h4 className="timeline-item--label font-weight-bold">
                    {this.formatDeliveryDate(row.deliveryDate)}
                  </h4>
                  <p className="mt-2 text-black-50 font-weight-bold">
                    {row.dateCreation
                      ? moment
                          .utc(row.dateCreation)
                          .local()
                          .format(this.props.appState.longDateFormat)
                      : ''}
                    {row.createdByEmail ? ' (' + row.createdByEmail + ')' : ''}
                  </p>
                  <p className="mt-2 text-black">
                    {this.translatorService.Tranlate(
                      'ORDER_PART_HISTORY_DAYS_ADDED',
                      'Zile adaugate'
                    )}
                    {': '}
                    {row.extensionDaysAdded ?? 'N/A'}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    );
  };

  handleOpenHistory = async (partId: number) => {
    try {
      const history = await this.orderService.GetOrderPartDeliveryDateHistory(partId);
      this.setState({ isHistoryDialogOpen: true, historyDialogData: history });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleCloseHistory = () => {
    this.closeHistoryDialog();
  };

  handleUploadAttachment = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const attachments = [...this.state.attachments];

      attachments.push({
        id: 0,
        caseId: this.props.orderDetails.caseId,
        attachmentTypeId: this.state.attachType!.id,
        attachmentType: this.state.attachType,
        file: e.target.files![0],
        fileName: e.target.files![0].name,
        uploadDate: new Date(),
        carPhotos: false,
        originalFileName: e.target.files![0].name,
        caseRequestId: null,
        paymentId: null,
        serviceAppointmentId: null,
        caseClientId: null,
        isSelection: false
      });

      this.setState({
        attachments: attachments
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleDeleteAttachment = async (id: number, fileName: string) => {
    try {
      const attachments = [...this.state.attachments];
      const index = attachments.findIndex((item) => item.id === id);
      attachments.splice(index, 1);

      this.setState({
        attachments: attachments
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  renderAttachmentBox = () => {
    return (
      <Grid container spacing={2} className="mt-2">
        <Grid item xs={9}>
          {this.state.attachments.length !== 0
            ? this.state.attachments.map((attach, index) => {
                return (
                  <div key={index} className="d-flex flex-row w-100">
                    <div className="w-75 text-left">
                      <Button
                        color="primary"
                        className="text-primary text-left pl-0"
                        disabled={false}
                        onClick={(e) => this.downloadFile(attach.fileName, attach.originalFileName)}
                      >
                        <span className="crop">{attach.originalFileName}</span>
                      </Button>
                    </div>
                    <div className="w-25">
                      <IconButton
                        aria-label="delete"
                        color="inherit"
                        className="text-danger"
                        size="small"
                        onClick={(e) => this.handleDeleteAttachment(attach.id, attach.fileName)}
                        disabled={false}
                      >
                        <DeleteOutlineTwoToneIcon />
                      </IconButton>
                    </div>
                  </div>
                );
              })
            : null}
        </Grid>
        <Grid item xs={3} container justify="flex-end" direction="column">
          <input
            className="d-none"
            id={'contained-button-file'}
            disabled={false}
            onChange={(e) => {
              return this.handleUploadAttachment(e);
            }}
            type="file"
          />
          <label className="mb-0" htmlFor={'contained-button-file'}>
            <Button
              variant="outlined"
              size="small"
              color="primary"
              disabled={false}
              className="d-block text-center shadow-none"
              component="div"
            >
              {this.translatorService.Tranlate(
                'ORDER_PART_DETAILS_DIALOG_ATTACH_BTN_LABEL',
                'Atasament'
              )}
            </Button>
          </label>
        </Grid>
      </Grid>
    );
  };

  deleteOrderPart = (event: any, tableMeta: MUIDataTableMeta) => {
    const id = tableMeta.rowData[0];
    this.setState({ pendingDeletePartId: id, isRequeryDialogOpen: true });
  };

  handleRequeryConfirm = async (shouldRequery: boolean) => {
    const { pendingDeletePartId } = this.state;

    if (pendingDeletePartId == null) return;

    try {
      const newArray = [...this.state.orderpartsList];
      const selectedPartIndex = newArray.findIndex((item) => item.id === pendingDeletePartId);
      const part = newArray[selectedPartIndex];
      const groupedPartIds = newArray
        .filter((item) => item.groupedUniqueId === part.groupedUniqueId)
        .map((item) => item.id);

      await this.orderService.DeleteOrderPartWithChoice({
        orderPartIds: groupedPartIds,
        shouldRequery
      });

      newArray.forEach((item) => {
        if (groupedPartIds.includes(item.id)) item.isDeleted = true;
      });
      const order = await this.orderService.GetOrder(this.props.orderDetails.id, false);
      const orderStatusHistory = await this.orderService.GetOrderStatusHistories(
        this.props.orderDetails.id
      );

      order.orderParts = newArray;
      this.props.onOrderChange(order);
      this.setState({
        orderpartsList: newArray,
        orderStatusHistory: orderStatusHistory,
        isRequeryDialogOpen: false,
        pendingDeletePartId: null
      });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  renderChangeOrderStatusForm = () => {
    const hasOrderPartsChangedBySupplier =
      this.state.hasSupplierRole &&
      this.props.orderDetails?.orderStatus?.code === OrderStatusCode.FZR_VERIFICARE_LA_FURNIZOR &&
      !this.checkIfOrderPartsVerifiedBySupplier();
    return (
      <ValidatorForm
        onSubmit={(e) => {
          this.changeOrderStatusSubmit();
        }}
      >
        {hasOrderPartsChangedBySupplier ? (
          <div className="mb-2" style={{ color: 'red' }}>
            {this.translatorService.Tranlate(
              'ORDER_NOTIFICATIONS_NO_CHANGES_ON_PARTS_SUPPLIER_LABEL',
              'Nu au fost efectuate modificări în comandă. La salvare, comanda va fi lansată automat. Doriți să continuați?'
            )}
          </div>
        ) : null}
        <div className="text-center m-0">
          <TextValidator
            fullWidth
            disabled={false}
            id="textComment"
            name="textComment"
            multiline
            rows={5}
            label={this.translatorService.Tranlate(
              'ORDER_PART_DETAILS_DIALOG_COMMENT_LABEL',
              'Comentariu'
            )}
            value={this.state.changeOrderStatusComment}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              this.setState({
                changeOrderStatusComment: e.target.value
              });
            }}
            variant="outlined"
            validators={!this.props.workflowAutomatePlaceOrder ? ['required'] : undefined}
            errorMessages={
              !this.props.workflowAutomatePlaceOrder
                ? [
                    this.translatorService.Tranlate(
                      'VALIDATORS_REQUIRED',
                      'Campul este obligatoriu'
                    )
                  ]
                : undefined
            }
          />
          {this.renderAttachmentBox()}
        </div>
        <Button
          className="mt-3 float-right"
          variant="contained"
          color="secondary"
          type="submit"
          disabled={this.state.executing}
        >
          {hasOrderPartsChangedBySupplier
            ? this.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_YES', 'Da')
            : this.translatorService.Tranlate('CASE_COMMENT_SEND', 'Trimite')}
        </Button>
        {hasOrderPartsChangedBySupplier ? (
          <Button
            className="mt-3 mr-2 float-right"
            variant="outlined"
            color="secondary"
            disabled={this.state.executing}
            onClick={(e) => {
              this.setState({ isChangeOrderStatusDialogOpen: false });
            }}
          >
            {this.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_NO', 'Nu')}
          </Button>
        ) : null}
      </ValidatorForm>
    );
  };

  downloadFile = async (fileName: string, origFileName: string) => {
    const fileBlob = await this.caseService.GetCaseAttachment(fileName);
    FileSaver.saveAs(fileBlob, origFileName);
  };

  showOrdeStatusTimelineHistory = () => {
    const orderStatusHistory = this.state.orderStatusHistory;

    if (orderStatusHistory.length === 0) {
      return (
        <b>
          {this.translatorService.Tranlate(
            'ORDER_DETAILS_HISTORY_NO_DATA',
            'Nu exista date de afisat!'
          )}
        </b>
      );
    }

    return (
      <div className="timeline-list  timeline-list--primary">
        {orderStatusHistory.map((orderStatus, index) => (
          <div key={index} className="timeline-item">
            <div className="timeline-item--content">
              <div className="timeline-item--icon " />
              <h4 className="timeline-item--label font-weight-bold">
                {' '}
                {orderStatus.orderStatus!.displayName}
              </h4>
              <p className="mt-2 text-black-50 font-weight-bold">
                {moment.utc(orderStatus.date).local().format(this.props.appState.longDateFormat)}
                {!isNullOrUndefined(orderStatus.createdByUser)
                  ? '(' + orderStatus.createdByUser.userName + ')'
                  : ''}
              </p>
              <p className="mt-2 text-black">{orderStatus.comment}</p>

              {orderStatus.attachments === null
                ? null
                : orderStatus.attachments.map((attach, index) => {
                    return (
                      <div key={index} className="d-flex flex-row w-100">
                        <div className="w-75 text-left" key={index}>
                          <Button
                            color="primary"
                            className="text-primary text-left"
                            onClick={(e) =>
                              this.downloadFile(attach.fileName, attach.originalFileName)
                            }
                          >
                            <span className="crop">{attach.originalFileName}</span>
                          </Button>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>
        ))}
      </div>
    );
  };

  handleAlternativePartSelectWithStockCheck = (
    id: number,
    orderPartIndex: number,
    originalPartId: number,
    alternativePart: CaseCalculationAlternativePart,
    pieceNr: number
  ) => {
    if (
      !R.isNil(alternativePart.availableQuantity) &&
      alternativePart.availableQuantity < pieceNr
    ) {
      this.setState({
        isStockExceededConfirmOpen: true,
        stockExceededPendingAction: () =>
          this.handleAlternativePartSelect(id, orderPartIndex, originalPartId, alternativePart)
      });
      return;
    }
    this.handleAlternativePartSelect(id, orderPartIndex, originalPartId, alternativePart);
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.orderService = (this.context as AppContext).orderService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    this.appUserService = (this.context as AppContext).appUserService;
    this.caseService = (this.context as AppContext).caseService;
    this.organizationService = (this.context as AppContext).organizationService;
    this.workflowService = (this.context as AppContext).workflowService;
    this.refreshService = (this.context as AppContext).refreshService;

    const options = {
      filter: false,
      viewColumns: false,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      elevation: 0,
      textLabels: MUITranslations.GetTranslations(this.translatorService)
      // responsive: "stacked",
    };

    return (
      <React.Fragment>
        {this.renderOrderDetailsSection()}
        {this.renderInterogateAllSection()}
        {this.renderOrderPartsSection()}
        <Card className="mt-2">
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoadingOrderDetails} />
          </div>

          {!this.state.isLoadingOrderDetails && this.state.showOrderPrice ? (
            <div>
              <div style={{ backgroundColor: '#cccccc' }} className="card-header text-black">
                <span className="mb-0 py-2 font-weight-bold">
                  {this.translatorService.Tranlate('ORDER_DETAILS_TOTAL_TITLE', 'TOTAL COMANDA')}
                </span>
              </div>
              <CardContent className="p-3">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <div className="">
                      <p className="m-0">
                        <span className="font-weight-bold">
                          {this.translatorService.Tranlate(
                            'ORDER_DETAILS_TOTAL_NO_TVA_LABEL',
                            'Total fara TVA'
                          ) + ': '}{' '}
                        </span>
                        {Utils.countryNumberFormat(
                          this.props.orderDetails.amountWithoutTVA.toFixed(2),
                          this.props.appState.appUser?.organization?.country ?? null
                        ) +
                          ' ' +
                          (!isNullOrUndefined(this.props.orderDetails.currencyCode) &&
                          this.props.orderDetails.currencyCode !== ''
                            ? this.props.orderDetails.currencyCode
                            : '')}
                      </p>
                      <p className="m-0">
                        <span className="font-weight-bold">
                          {this.translatorService.Tranlate('ORDER_DETAILS_TVA_LABEL', 'TVA')}
                          {this.state.TVA !== '' && !isNullOrUndefined(this.state.TVA)
                            ? ' (' + this.state.TVA + '%)'
                            : ''}
                          :{' '}
                        </span>
                        {Utils.countryNumberFormat(
                          this.props.orderDetails.amountTVA.toFixed(2),
                          this.props.appState.appUser?.organization?.country ?? null
                        ) +
                          ' ' +
                          (!isNullOrUndefined(this.props.orderDetails.currencyCode) &&
                          this.props.orderDetails.currencyCode !== ''
                            ? this.props.orderDetails.currencyCode
                            : '')}
                      </p>
                      <p className="m-0">
                        <span className="font-weight-bold">
                          {this.translatorService.Tranlate('ORDER_DETAILS_TOTAL_LABEL', 'Total') +
                            ': '}
                        </span>
                        {Utils.countryNumberFormat(
                          this.props.orderDetails.amount.toFixed(2),
                          this.props.appState.appUser?.organization?.country ?? null
                        ) +
                          ' ' +
                          (!isNullOrUndefined(this.props.orderDetails.currencyCode) &&
                          this.props.orderDetails.currencyCode !== ''
                            ? this.props.orderDetails.currencyCode
                            : '')}
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </div>
          ) : null}
        </Card>

        <Card className="mt-2">
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoadingOrderDetails} />
          </div>
          {!this.state.isLoadingOrderDetails ? (
            <div>
              <div style={{ backgroundColor: '#cccccc' }} className="card-header text-black">
                <span className="mb-0 py-2 font-weight-bold">
                  {this.translatorService.Tranlate(
                    'ORDER_DETAILS_HISTORY_TITLE',
                    'ISTORIC COMANDA'
                  )}
                </span>
              </div>
              <CardContent className="p-3">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {this.showOrdeStatusTimelineHistory()}
                  </Grid>
                </Grid>
              </CardContent>
            </div>
          ) : null}
        </Card>
        <Dialog
          onClose={this.closeDialog}
          aria-labelledby="customized-dialog-title"
          open={this.state.isChangeOrderStatusDialogOpen}
          fullScreen={false}
          fullWidth={true}
        >
          <DialogTitle
            id="customized-dialog-title"
            style={{ color: '#ffffff', backgroundColor: 'var(--primary)', textAlign: 'center' }}
          >
            <span>
              {this.translatorService.Tranlate(
                'ORDER_DETAILS_DIALOG_TITLE',
                'Modificare stare comanda'
              )}
            </span>
            <IconButton
              aria-label="close"
              className="position-absolute"
              style={{ right: 12, top: 12, color: '#ffffff' }}
              onClick={this.closeDialog}
              size={'small'}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className="p-3" dividers style={{ backgroundColor: '#fafafa' }}>
            {this.renderChangeOrderStatusForm()}
          </DialogContent>
        </Dialog>
        <RequeryDialog
          open={this.state.isRequeryDialogOpen}
          onConfirm={this.handleRequeryConfirm}
          onClose={() => this.setState({ isRequeryDialogOpen: false, pendingDeletePartId: null })}
          title={this.translatorService.Tranlate(
            'ORDER_DETAILS_REQUERY_DIALOG_TITLE',
            'Confirmare ștergere piesă'
          )}
          message={this.translatorService.Tranlate(
            'ORDER_DETAILS_REQUERY_DIALOG_MESSAGE',
            'Doriți să reinterogați piesa la un alt furnizor?'
          )}
          yesLabel={this.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_YES', 'Da')}
          noLabel={this.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_NO', 'Nu')}
        />
        <QuantityWarningDialog
          open={this.state.isDialogOpenQuantityWarning}
          onConfirm={() => {
            const action = this.state.quantityWarningPendingAction;
            this.setState({
              isDialogOpenQuantityWarning: false,
              quantityWarningInfo: null,
              quantityWarningPendingAction: null
            });
            if (action) action();
          }}
          onClose={() => {
            this.setState({
              isDialogOpenQuantityWarning: false,
              quantityWarningInfo: null,
              quantityWarningPendingAction: null
            });
          }}
          title={this.translatorService.Tranlate('QUANTITY_WARNING_DIALOG_TITLE', 'Cantitate mare')}
          message={this.translatorService.Tranlate(
            'QUANTITY_WARNING_DIALOG_MESSAGE',
            'Cantitatea introdusă este mai mare sau egală cu 10. Doriți să continuați?'
          )}
          quantityLabel={this.translatorService.Tranlate(
            'QUANTITY_WARNING_DIALOG_QUANTITY_LABEL',
            'Cantitate'
          )}
          yesLabel={this.translatorService.Tranlate('WORKFLOW_DOCUMENTS_TYPE_TAB_YES', 'Da')}
          noLabel={this.translatorService.Tranlate('WORKFLOW_DOCUMENTS_TYPE_TAB_NO', 'Nu')}
          partInfo={this.state.quantityWarningInfo}
        />
        <ConfirmDialog
          open={this.state.isStockExceededConfirmOpen}
          onConfirm={() => {
            const action = this.state.stockExceededPendingAction;
            this.setState({ isStockExceededConfirmOpen: false, stockExceededPendingAction: null });
            if (action) action();
          }}
          onClose={() => {
            this.setState({ isStockExceededConfirmOpen: false, stockExceededPendingAction: null });
          }}
          title={this.translatorService.Tranlate('STOCK_EXCEEDED_CONFIRM_TITLE', 'Stoc insuficient')}
          message={this.translatorService.Tranlate(
            'STOCK_EXCEEDED_CONFIRM_MESSAGE',
            'Cantitatea selectata depășește stocul disponibil. Doriți să continuați?'
          )}
          yesLabel={this.translatorService.Tranlate('WORKFLOW_DOCUMENTS_TYPE_TAB_YES', 'Da')}
          noLabel={this.translatorService.Tranlate('WORKFLOW_DOCUMENTS_TYPE_TAB_NO', 'Nu')}
        />
        <RequeryDialog
          open={this.state.isCancelPartRequeryDialogOpen}
          onConfirm={this.handleCancelPartRequeryConfirm}
          onClose={() =>
            this.setState({ isCancelPartRequeryDialogOpen: false, pendingUpdateStatusPartId: null })
          }
          title={this.translatorService.Tranlate(
            'ORDER_PART_CANCEL_DIALOG_TITLE',
            'Confirmare anulare piesă'
          )}
          message={this.translatorService.Tranlate(
            'ORDER_PART_CANCEL_REQUERY_MESSAGE',
            'Doriți să reinterogați piesa la un alt furnizor?'
          )}
          yesLabel={this.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_YES', 'Da')}
          noLabel={this.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_NO', 'Nu')}
        />
        <Dialog
          onClose={this.closeExtendDialog}
          open={this.state.isExtendDialogOpen}
          fullScreen={false}
          fullWidth={true}
          maxWidth="xs"
        >
          <DialogTitle
            style={{ color: '#ffffff', backgroundColor: 'var(--primary)', textAlign: 'center' }}
          >
            <span>
              {this.translatorService.Tranlate(
                'ORDER_PART_EXTEND_DELIVERY_LABEL',
                'Prelungire livrare'
              )}
            </span>
            <IconButton
              aria-label="close"
              className="position-absolute"
              style={{ right: 12, top: 12, color: '#ffffff' }}
              onClick={this.closeExtendDialog}
              size={'small'}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          {this.renderExtendDeliveryForm()}
        </Dialog>
        <Dialog
          onClose={this.handleCloseHistory}
          open={this.state.isHistoryDialogOpen}
          fullScreen={false}
          fullWidth={true}
          maxWidth="md"
        >
          <DialogTitle
            style={{ color: '#ffffff', backgroundColor: 'var(--primary)', textAlign: 'center' }}
          >
            <span>
              {this.translatorService.Tranlate(
                'ORDER_PART_DELIVERY_HISTORY_LABEL',
                'Istoric livrare'
              )}
            </span>
            <IconButton
              aria-label="close"
              className="position-absolute"
              style={{ right: 12, top: 12, color: '#ffffff' }}
              onClick={this.handleCloseHistory}
              size={'small'}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          {this.renderDeliveryDateHistory()}
        </Dialog>
      </React.Fragment>
    );
  }
}

const mergeProps = (stateProps: any, dispatchProps: any, ownProps: ExternalOrderDetailsProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});

export default connect(
  (state: ApplicationState) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app
  }),
  null,
  mergeProps
)(withSnackbar(OrderDetails as any));
